<template>
    <div class="relative">
        <svg viewBox="0 0 845.2 458">
            <circle class="st0" cx="826.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="819.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="819.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="812.6" cy="90" r="1.9" />
            <circle class="st0" cx="812.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="812.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="805.8" cy="90" r="1.9" />
            <circle class="st0" cx="805.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="805.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="805.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="805.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="805.8" cy="381.6" r="1.9" />
            <circle class="st0" cx="799" cy="96.7" r="1.9" />
            <circle class="st0" cx="799" cy="103.5" r="1.9" />
            <circle class="st0" cx="799" cy="110.3" r="1.9" />
            <circle class="st0" cx="799" cy="117.1" r="1.9" />
            <circle class="st0" cx="799" cy="123.9" r="1.9" />
            <circle class="st0" cx="799" cy="374.8" r="1.9" />
            <circle class="st0" cx="799" cy="381.6" r="1.9" />
            <circle class="st0" cx="799" cy="388.4" r="1.9" />
            <circle class="st0" cx="792.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="792.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="792.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="792.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="792.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="792.2" cy="368" r="1.9" />
            <circle class="st0" cx="792.2" cy="374.8" r="1.9" />
            <circle class="st0" cx="792.2" cy="381.6" r="1.9" />
            <circle class="st0" cx="792.2" cy="388.4" r="1.9" />
            <circle class="st0" cx="792.2" cy="395.2" r="1.9" />
            <circle class="st0" cx="785.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="785.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="785.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="785.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="785.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="785.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="785.4" cy="395.2" r="1.9" />
            <circle class="st0" cx="785.4" cy="402" r="1.9" />
            <circle class="st0" cx="778.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="778.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="778.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="778.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="778.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="778.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="778.7" cy="334.1" r="1.9" />
            <circle class="st0" cx="778.7" cy="340.9" r="1.9" />
            <circle class="st0" cx="778.7" cy="395.2" r="1.9" />
            <circle class="st0" cx="778.7" cy="402" r="1.9" />
            <circle class="st0" cx="771.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="771.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="771.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="771.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="771.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="771.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="771.9" cy="334.1" r="1.9" />
            <circle class="st0" cx="771.9" cy="340.9" r="1.9" />
            <circle class="st0" cx="765.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="765.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="765.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="765.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="765.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="765.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="765.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="765.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="765.1" cy="151" r="1.9" />
            <circle class="st0" cx="758.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="758.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="758.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="758.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="758.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="758.3" cy="137.4" r="1.9" />
            <circle class="st0" cx="758.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="758.3" cy="151" r="1.9" />
            <circle class="st0" cx="758.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="758.3" cy="307" r="1.9" />
            <circle class="st0" cx="751.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="751.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="751.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="751.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="751.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="751.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="751.5" cy="151" r="1.9" />
            <circle class="st0" cx="751.5" cy="307" r="1.9" />
            <circle class="st0" cx="744.7" cy="90" r="1.9" />
            <circle class="st0" cx="744.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="744.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="744.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="744.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="744.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="744.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="744.7" cy="300.2" r="1.9" />
            <circle class="st0" cx="744.7" cy="347.7" r="1.9" />
            <circle class="st0" cx="744.7" cy="354.5" r="1.9" />
            <circle class="st0" cx="744.7" cy="361.3" r="1.9" />
            <circle class="st0" cx="738" cy="76.4" r="1.9" />
            <circle class="st0" cx="738" cy="90" r="1.9" />
            <circle class="st0" cx="738" cy="96.7" r="1.9" />
            <circle class="st0" cx="738" cy="103.5" r="1.9" />
            <circle class="st0" cx="738" cy="110.3" r="1.9" />
            <circle class="st0" cx="738" cy="117.1" r="1.9" />
            <circle class="st0" cx="738" cy="123.9" r="1.9" />
            <circle class="st0" cx="738" cy="130.7" r="1.9" />
            <circle class="st0" cx="738" cy="300.2" r="1.9" />
            <circle class="st0" cx="738" cy="313.8" r="1.9" />
            <circle class="st0" cx="738" cy="340.9" r="1.9" />
            <circle class="st0" cx="738" cy="347.7" r="1.9" />
            <circle class="st0" cx="738" cy="354.5" r="1.9" />
            <circle class="st0" cx="738" cy="361.3" r="1.9" />
            <circle class="st0" cx="738" cy="368" r="1.9" />
            <circle class="st0" cx="738" cy="374.8" r="1.9" />
            <circle class="st0" cx="731.2" cy="76.4" r="1.9" />
            <circle class="st0" cx="731.2" cy="90" r="1.9" />
            <circle class="st0" cx="731.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="731.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="731.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="731.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="731.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="731.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="731.2" cy="300.2" r="1.9" />
            <circle class="st0" cx="731.2" cy="307" r="1.9" />
            <circle class="st0" cx="731.2" cy="327.3" r="1.9" />
            <circle class="st0" cx="731.2" cy="334.1" r="1.9" />
            <circle class="st0" cx="731.2" cy="340.9" r="1.9" />
            <circle class="st0" cx="731.2" cy="347.7" r="1.9" />
            <circle class="st0" cx="731.2" cy="354.5" r="1.9" />
            <circle class="st0" cx="731.2" cy="361.3" r="1.9" />
            <circle class="st0" cx="731.2" cy="368" r="1.9" />
            <circle class="st0" cx="731.2" cy="374.8" r="1.9" />
            <circle class="st0" cx="731.2" cy="381.6" r="1.9" />
            <circle class="st0" cx="731.2" cy="388.4" r="1.9" />
            <circle class="st0" cx="724.4" cy="69.6" r="1.9" />
            <circle class="st0" cx="724.4" cy="76.4" r="1.9" />
            <circle class="st0" cx="724.4" cy="83.2" r="1.9" />
            <circle class="st0" cx="724.4" cy="90" r="1.9" />
            <circle class="st0" cx="724.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="724.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="724.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="724.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="724.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="724.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="724.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="724.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="724.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="724.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="724.4" cy="184.9" r="1.9" />
            <circle class="st0" cx="724.4" cy="300.2" r="1.9" />
            <circle class="st0" cx="724.4" cy="307" r="1.9" />
            <circle class="st0" cx="724.4" cy="320.6" r="1.9" />
            <circle class="st0" cx="724.4" cy="327.3" r="1.9" />
            <circle class="st0" cx="724.4" cy="334.1" r="1.9" />
            <circle class="st0" cx="724.4" cy="340.9" r="1.9" />
            <circle class="st0" cx="724.4" cy="347.7" r="1.9" />
            <circle class="st0" cx="724.4" cy="354.5" r="1.9" />
            <circle class="st0" cx="724.4" cy="361.3" r="1.9" />
            <circle class="st0" cx="724.4" cy="368" r="1.9" />
            <circle class="st0" cx="724.4" cy="374.8" r="1.9" />
            <circle class="st0" cx="724.4" cy="381.6" r="1.9" />
            <circle class="st0" cx="717.6" cy="69.6" r="1.9" />
            <circle class="st0" cx="717.6" cy="76.4" r="1.9" />
            <circle class="st0" cx="717.6" cy="83.2" r="1.9" />
            <circle class="st0" cx="717.6" cy="90" r="1.9" />
            <circle class="st0" cx="717.6" cy="96.7" r="1.9" />
            <circle class="st0" cx="717.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="717.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="717.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="717.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="717.6" cy="130.7" r="1.9" />
            <circle class="st0" cx="717.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="717.6" cy="151" r="1.9" />
            <circle class="st0" cx="717.6" cy="157.8" r="1.9" />
            <circle class="st0" cx="717.6" cy="164.6" r="1.9" />
            <circle class="st0" cx="717.6" cy="171.3" r="1.9" />
            <circle class="st0" cx="717.6" cy="178.1" r="1.9" />
            <circle class="st0" cx="717.6" cy="184.9" r="1.9" />
            <circle class="st0" cx="717.6" cy="191.7" r="1.9" />
            <circle class="st0" cx="717.6" cy="198.5" r="1.9" />
            <circle class="st0" cx="717.6" cy="205.3" r="1.9" />
            <circle class="st0" cx="717.6" cy="293.4" r="1.9" />
            <circle class="st0" cx="717.6" cy="300.2" r="1.9" />
            <circle class="st0" cx="717.6" cy="307" r="1.9" />
            <circle class="st0" cx="717.6" cy="327.3" r="1.9" />
            <circle class="st0" cx="717.6" cy="334.1" r="1.9" />
            <circle class="st0" cx="717.6" cy="340.9" r="1.9" />
            <circle class="st0" cx="717.6" cy="347.7" r="1.9" />
            <circle class="st0" cx="717.6" cy="354.5" r="1.9" />
            <circle class="st0" cx="717.6" cy="361.3" r="1.9" />
            <circle class="st0" cx="717.6" cy="368" r="1.9" />
            <circle class="st0" cx="717.6" cy="374.8" r="1.9" />
            <circle class="st0" cx="710.8" cy="69.6" r="1.9" />
            <circle class="st0" cx="710.8" cy="76.4" r="1.9" />
            <circle class="st0" cx="710.8" cy="90" r="1.9" />
            <circle class="st0" cx="710.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="710.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="710.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="710.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="710.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="710.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="710.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="710.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="710.8" cy="151" r="1.9" />
            <circle class="st0" cx="710.8" cy="157.8" r="1.9" />
            <circle class="st0" cx="710.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="710.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="710.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="710.8" cy="198.5" r="1.9" />
            <circle class="st0" cx="710.8" cy="205.3" r="1.9" />
            <circle class="st0" cx="710.8" cy="293.4" r="1.9" />
            <circle class="st0" cx="710.8" cy="300.2" r="1.9" />
            <circle class="st0" cx="710.8" cy="307" r="1.9" />
            <circle class="st0" cx="710.8" cy="327.3" r="1.9" />
            <circle class="st0" cx="710.8" cy="334.1" r="1.9" />
            <circle class="st0" cx="710.8" cy="340.9" r="1.9" />
            <circle class="st0" cx="710.8" cy="347.7" r="1.9" />
            <circle class="st0" cx="710.8" cy="354.5" r="1.9" />
            <circle class="st0" cx="710.8" cy="361.3" r="1.9" />
            <circle class="st0" cx="710.8" cy="368" r="1.9" />
            <circle class="st0" cx="704" cy="90" r="1.9" />
            <circle class="st0" cx="704" cy="96.7" r="1.9" />
            <circle class="st0" cx="704" cy="103.5" r="1.9" />
            <circle class="st0" cx="704" cy="110.3" r="1.9" />
            <circle class="st0" cx="704" cy="117.1" r="1.9" />
            <circle class="st0" cx="704" cy="123.9" r="1.9" />
            <circle class="st0" cx="704" cy="130.7" r="1.9" />
            <circle class="st0" cx="704" cy="137.4" r="1.9" />
            <circle class="st0" cx="704" cy="144.2" r="1.9" />
            <circle class="st0" cx="704" cy="151" r="1.9" />
            <circle class="st0" cx="704" cy="157.8" r="1.9" />
            <circle class="st0" cx="704" cy="164.6" r="1.9" />
            <circle class="st0" cx="704" cy="171.3" r="1.9" />
            <circle class="st0" cx="704" cy="178.1" r="1.9" />
            <circle class="st0" cx="704" cy="184.9" r="1.9" />
            <circle class="st0" cx="704" cy="205.3" r="1.9" />
            <circle class="st0" cx="704" cy="293.4" r="1.9" />
            <circle class="st0" cx="704" cy="300.2" r="1.9" />
            <circle class="st0" cx="704" cy="307" r="1.9" />
            <circle class="st0" cx="704" cy="320.6" r="1.9" />
            <circle class="st0" cx="704" cy="327.3" r="1.9" />
            <circle class="st0" cx="704" cy="334.1" r="1.9" />
            <circle class="st0" cx="704" cy="340.9" r="1.9" />
            <circle class="st0" cx="704" cy="347.7" r="1.9" />
            <circle class="st0" cx="704" cy="354.5" r="1.9" />
            <circle class="st0" cx="704" cy="361.3" r="1.9" />
            <circle class="st0" cx="704" cy="368" r="1.9" />
            <circle class="st0" cx="697.3" cy="90" r="1.9" />
            <circle class="st0" cx="697.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="697.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="697.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="697.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="697.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="697.3" cy="130.7" r="1.9" />
            <circle class="st0" cx="697.3" cy="137.4" r="1.9" />
            <circle class="st0" cx="697.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="697.3" cy="151" r="1.9" />
            <circle class="st0" cx="697.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="697.3" cy="164.6" r="1.9" />
            <circle class="st0" cx="697.3" cy="171.3" r="1.9" />
            <circle class="st0" cx="697.3" cy="178.1" r="1.9" />
            <circle class="st0" cx="697.3" cy="184.9" r="1.9" />
            <circle class="st0" cx="697.3" cy="205.3" r="1.9" />
            <circle class="st0" cx="697.3" cy="212" r="1.9" />
            <circle class="st0" cx="697.3" cy="218.8" r="1.9" />
            <circle class="st0" cx="697.3" cy="293.4" r="1.9" />
            <circle class="st0" cx="697.3" cy="307" r="1.9" />
            <circle class="st0" cx="697.3" cy="313.8" r="1.9" />
            <circle class="st0" cx="697.3" cy="320.6" r="1.9" />
            <circle class="st0" cx="697.3" cy="327.3" r="1.9" />
            <circle class="st0" cx="697.3" cy="334.1" r="1.9" />
            <circle class="st0" cx="697.3" cy="340.9" r="1.9" />
            <circle class="st0" cx="697.3" cy="347.7" r="1.9" />
            <circle class="st0" cx="697.3" cy="354.5" r="1.9" />
            <circle class="st0" cx="697.3" cy="361.3" r="1.9" />
            <circle class="st0" cx="690.5" cy="83.2" r="1.9" />
            <circle class="st0" cx="690.5" cy="90" r="1.9" />
            <circle class="st0" cx="690.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="690.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="690.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="690.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="690.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="690.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="690.5" cy="137.4" r="1.9" />
            <circle class="st0" cx="690.5" cy="144.2" r="1.9" />
            <circle class="st0" cx="690.5" cy="151" r="1.9" />
            <circle class="st0" cx="690.5" cy="157.8" r="1.9" />
            <circle class="st0" cx="690.5" cy="164.6" r="1.9" />
            <circle class="st0" cx="690.5" cy="171.3" r="1.9" />
            <circle class="st0" cx="690.5" cy="178.1" r="1.9" />
            <circle class="st0" cx="690.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="690.5" cy="191.7" r="1.9" />
            <circle class="st0" cx="690.5" cy="198.5" r="1.9" />
            <circle class="st0" cx="690.5" cy="205.3" r="1.9" />
            <circle class="st0" cx="690.5" cy="225.6" r="1.9" />
            <circle class="st0" cx="690.5" cy="286.6" r="1.9" />
            <circle class="st0" cx="690.5" cy="293.4" r="1.9" />
            <circle class="st0" cx="690.5" cy="320.6" r="1.9" />
            <circle class="st0" cx="690.5" cy="327.3" r="1.9" />
            <circle class="st0" cx="690.5" cy="334.1" r="1.9" />
            <circle class="st0" cx="690.5" cy="340.9" r="1.9" />
            <circle class="st0" cx="690.5" cy="347.7" r="1.9" />
            <circle class="st0" cx="690.5" cy="354.5" r="1.9" />
            <circle class="st0" cx="690.5" cy="361.3" r="1.9" />
            <circle class="st0" cx="683.7" cy="83.2" r="1.9" />
            <circle class="st0" cx="683.7" cy="90" r="1.9" />
            <circle class="st0" cx="683.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="683.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="683.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="683.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="683.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="683.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="683.7" cy="137.4" r="1.9" />
            <circle class="st0" cx="683.7" cy="144.2" r="1.9" />
            <circle class="st0" cx="683.7" cy="151" r="1.9" />
            <circle class="st0" cx="683.7" cy="157.8" r="1.9" />
            <circle class="st0" cx="683.7" cy="164.6" r="1.9" />
            <circle class="st0" cx="683.7" cy="171.3" r="1.9" />
            <circle class="st0" cx="683.7" cy="178.1" r="1.9" />
            <circle class="st0" cx="683.7" cy="184.9" r="1.9" />
            <circle class="st0" cx="683.7" cy="191.7" r="1.9" />
            <circle class="st0" cx="683.7" cy="198.5" r="1.9" />
            <circle class="st0" cx="683.7" cy="259.5" r="1.9" />
            <circle class="st0" cx="683.7" cy="266.3" r="1.9" />
            <circle class="st0" cx="683.7" cy="273.1" r="1.9" />
            <circle class="st0" cx="683.7" cy="286.6" r="1.9" />
            <circle class="st0" cx="683.7" cy="293.4" r="1.9" />
            <circle class="st0" cx="683.7" cy="300.2" r="1.9" />
            <circle class="st0" cx="683.7" cy="307" r="1.9" />
            <circle class="st0" cx="683.7" cy="320.6" r="1.9" />
            <circle class="st0" cx="683.7" cy="327.3" r="1.9" />
            <circle class="st0" cx="683.7" cy="334.1" r="1.9" />
            <circle class="st0" cx="683.7" cy="340.9" r="1.9" />
            <circle class="st0" cx="683.7" cy="347.7" r="1.9" />
            <circle class="st0" cx="683.7" cy="354.5" r="1.9" />
            <circle class="st0" cx="683.7" cy="361.3" r="1.9" />
            <circle class="st0" cx="676.9" cy="83.2" r="1.9" />
            <circle class="st0" cx="676.9" cy="90" r="1.9" />
            <circle class="st0" cx="676.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="676.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="676.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="676.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="676.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="676.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="676.9" cy="137.4" r="1.9" />
            <circle class="st0" cx="676.9" cy="144.2" r="1.9" />
            <circle class="st0" cx="676.9" cy="151" r="1.9" />
            <circle class="st0" cx="676.9" cy="157.8" r="1.9" />
            <circle class="st0" cx="676.9" cy="164.6" r="1.9" />
            <circle class="st0" cx="676.9" cy="171.3" r="1.9" />
            <circle class="st0" cx="676.9" cy="178.1" r="1.9" />
            <circle class="st0" cx="676.9" cy="184.9" r="1.9" />
            <circle class="st0" cx="676.9" cy="191.7" r="1.9" />
            <circle class="st0" cx="676.9" cy="246" r="1.9" />
            <circle class="st0" cx="676.9" cy="252.7" r="1.9" />
            <circle class="st0" cx="676.9" cy="259.5" r="1.9" />
            <circle class="st0" cx="676.9" cy="266.3" r="1.9" />
            <circle class="st0" cx="676.9" cy="273.1" r="1.9" />
            <circle class="st0" cx="676.9" cy="286.6" r="1.9" />
            <circle class="st0" cx="676.9" cy="293.4" r="1.9" />
            <circle class="st0" cx="676.9" cy="300.2" r="1.9" />
            <circle class="st0" cx="676.9" cy="307" r="1.9" />
            <circle class="st0" cx="676.9" cy="313.8" r="1.9" />
            <circle class="st0" cx="676.9" cy="327.3" r="1.9" />
            <circle class="st0" cx="676.9" cy="334.1" r="1.9" />
            <circle class="st0" cx="676.9" cy="340.9" r="1.9" />
            <circle class="st0" cx="676.9" cy="347.7" r="1.9" />
            <circle class="st0" cx="676.9" cy="354.5" r="1.9" />
            <circle class="st0" cx="676.9" cy="361.3" r="1.9" />
            <circle class="st0" cx="676.9" cy="368" r="1.9" />
            <circle class="st0" cx="670.1" cy="83.2" r="1.9" />
            <circle class="st0" cx="670.1" cy="90" r="1.9" />
            <circle class="st0" cx="670.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="670.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="670.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="670.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="670.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="670.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="670.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="670.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="670.1" cy="151" r="1.9" />
            <circle class="st0" cx="670.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="670.1" cy="164.6" r="1.9" />
            <circle class="st0" cx="670.1" cy="171.3" r="1.9" />
            <circle class="st0" cx="670.1" cy="178.1" r="1.9" />
            <circle class="st0" cx="670.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="670.1" cy="191.7" r="1.9" />
            <circle class="st0" cx="670.1" cy="198.5" r="1.9" />
            <circle class="st0" cx="670.1" cy="205.3" r="1.9" />
            <circle class="st0" cx="670.1" cy="212" r="1.9" />
            <circle class="st0" cx="670.1" cy="218.8" r="1.9" />
            <circle class="st0" cx="670.1" cy="225.6" r="1.9" />
            <circle class="st0" cx="670.1" cy="232.4" r="1.9" />
            <circle class="st0" cx="670.1" cy="246" r="1.9" />
            <circle class="st0" cx="670.1" cy="252.7" r="1.9" />
            <circle class="st0" cx="670.1" cy="259.5" r="1.9" />
            <circle class="st0" cx="670.1" cy="286.6" r="1.9" />
            <circle class="st0" cx="670.1" cy="293.4" r="1.9" />
            <circle class="st0" cx="670.1" cy="300.2" r="1.9" />
            <circle class="st0" cx="670.1" cy="307" r="1.9" />
            <circle class="st0" cx="670.1" cy="313.8" r="1.9" />
            <circle class="st0" cx="670.1" cy="327.3" r="1.9" />
            <circle class="st0" cx="670.1" cy="334.1" r="1.9" />
            <circle class="st0" cx="670.1" cy="340.9" r="1.9" />
            <circle class="st0" cx="670.1" cy="347.7" r="1.9" />
            <circle class="st0" cx="670.1" cy="354.5" r="1.9" />
            <circle class="st0" cx="670.1" cy="361.3" r="1.9" />
            <circle class="st0" cx="670.1" cy="368" r="1.9" />
            <circle class="st0" cx="663.4" cy="83.2" r="1.9" />
            <circle class="st0" cx="663.4" cy="90" r="1.9" />
            <circle class="st0" cx="663.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="663.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="663.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="663.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="663.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="663.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="663.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="663.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="663.4" cy="151" r="1.9" />
            <circle class="st0" cx="663.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="663.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="663.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="663.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="663.4" cy="184.9" r="1.9" />
            <circle class="st0" cx="663.4" cy="191.7" r="1.9" />
            <circle class="st0" cx="663.4" cy="198.5" r="1.9" />
            <circle class="st0" cx="663.4" cy="205.3" r="1.9" />
            <circle class="st0" cx="663.4" cy="212" r="1.9" />
            <circle class="st0" cx="663.4" cy="218.8" r="1.9" />
            <circle class="st0" cx="663.4" cy="225.6" r="1.9" />
            <circle class="st0" cx="663.4" cy="232.4" r="1.9" />
            <circle class="st0" cx="663.4" cy="273.1" r="1.9" />
            <circle class="st0" cx="663.4" cy="279.9" r="1.9" />
            <circle class="st0" cx="663.4" cy="286.6" r="1.9" />
            <circle class="st0" cx="663.4" cy="293.4" r="1.9" />
            <circle class="st0" cx="663.4" cy="307" r="1.9" />
            <circle class="st0" cx="663.4" cy="340.9" r="1.9" />
            <circle class="st0" cx="663.4" cy="347.7" r="1.9" />
            <circle class="st0" cx="663.4" cy="354.5" r="1.9" />
            <circle class="st0" cx="663.4" cy="361.3" r="1.9" />
            <circle class="st0" cx="663.4" cy="368" r="1.9" />
            <circle class="st0" cx="656.6" cy="69.6" r="1.9" />
            <circle class="st0" cx="656.6" cy="76.4" r="1.9" />
            <circle class="st0" cx="656.6" cy="83.2" r="1.9" />
            <circle class="st0" cx="656.6" cy="90" r="1.9" />
            <circle class="st0" cx="656.6" cy="96.7" r="1.9" />
            <circle class="st0" cx="656.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="656.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="656.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="656.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="656.6" cy="130.7" r="1.9" />
            <circle class="st0" cx="656.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="656.6" cy="144.2" r="1.9" />
            <circle class="st0" cx="656.6" cy="151" r="1.9" />
            <circle class="st0" cx="656.6" cy="157.8" r="1.9" />
            <circle class="st0" cx="656.6" cy="164.6" r="1.9" />
            <circle class="st0" cx="656.6" cy="171.3" r="1.9" />
            <circle class="st0" cx="656.6" cy="178.1" r="1.9" />
            <circle class="st0" cx="656.6" cy="184.9" r="1.9" />
            <circle class="st0" cx="656.6" cy="191.7" r="1.9" />
            <circle class="st0" cx="656.6" cy="198.5" r="1.9" />
            <circle class="st0" cx="656.6" cy="205.3" r="1.9" />
            <circle class="st0" cx="656.6" cy="212" r="1.9" />
            <circle class="st0" cx="656.6" cy="218.8" r="1.9" />
            <circle class="st0" cx="656.6" cy="225.6" r="1.9" />
            <circle class="st0" cx="656.6" cy="232.4" r="1.9" />
            <circle class="st0" cx="656.6" cy="279.9" r="1.9" />
            <circle class="st0" cx="656.6" cy="286.6" r="1.9" />
            <circle class="st0" cx="656.6" cy="293.4" r="1.9" />
            <circle class="st0" cx="656.6" cy="307" r="1.9" />
            <circle class="st0" cx="656.6" cy="340.9" r="1.9" />
            <circle class="st0" cx="656.6" cy="347.7" r="1.9" />
            <circle class="st0" cx="656.6" cy="354.5" r="1.9" />
            <circle class="st0" cx="649.8" cy="69.6" r="1.9" />
            <circle class="st0" cx="649.8" cy="76.4" r="1.9" />
            <circle class="st0" cx="649.8" cy="83.2" r="1.9" />
            <circle class="st0" cx="649.8" cy="90" r="1.9" />
            <circle class="st0" cx="649.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="649.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="649.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="649.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="649.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="649.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="649.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="649.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="649.8" cy="151" r="1.9" />
            <circle class="st0" cx="649.8" cy="157.8" r="1.9" />
            <circle class="st0" cx="649.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="649.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="649.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="649.8" cy="184.9" r="1.9" />
            <circle class="st0" cx="649.8" cy="191.7" r="1.9" />
            <circle class="st0" cx="649.8" cy="198.5" r="1.9" />
            <circle class="st0" cx="649.8" cy="205.3" r="1.9" />
            <circle class="st0" cx="649.8" cy="212" r="1.9" />
            <circle class="st0" cx="649.8" cy="218.8" r="1.9" />
            <circle class="st0" cx="649.8" cy="225.6" r="1.9" />
            <circle class="st0" cx="649.8" cy="232.4" r="1.9" />
            <circle class="st0" cx="649.8" cy="239.2" r="1.9" />
            <circle class="st0" cx="649.8" cy="246" r="1.9" />
            <circle class="st0" cx="649.8" cy="286.6" r="1.9" />
            <circle class="st0" cx="649.8" cy="293.4" r="1.9" />
            <circle class="st0" cx="649.8" cy="307" r="1.9" />
            <circle class="st0" cx="643" cy="69.6" r="1.9" />
            <circle class="st0" cx="643" cy="76.4" r="1.9" />
            <circle class="st0" cx="643" cy="83.2" r="1.9" />
            <circle class="st0" cx="643" cy="90" r="1.9" />
            <circle class="st0" cx="643" cy="96.7" r="1.9" />
            <circle class="st0" cx="643" cy="103.5" r="1.9" />
            <circle class="st0" cx="643" cy="110.3" r="1.9" />
            <circle class="st0" cx="643" cy="117.1" r="1.9" />
            <circle class="st0" cx="643" cy="123.9" r="1.9" />
            <circle class="st0" cx="643" cy="130.7" r="1.9" />
            <circle class="st0" cx="643" cy="137.4" r="1.9" />
            <circle class="st0" cx="643" cy="144.2" r="1.9" />
            <circle class="st0" cx="643" cy="151" r="1.9" />
            <circle class="st0" cx="643" cy="157.8" r="1.9" />
            <circle class="st0" cx="643" cy="164.6" r="1.9" />
            <circle class="st0" cx="643" cy="171.3" r="1.9" />
            <circle class="st0" cx="643" cy="178.1" r="1.9" />
            <circle class="st0" cx="643" cy="184.9" r="1.9" />
            <circle class="st0" cx="643" cy="191.7" r="1.9" />
            <circle class="st0" cx="643" cy="198.5" r="1.9" />
            <circle class="st0" cx="643" cy="205.3" r="1.9" />
            <circle class="st0" cx="643" cy="212" r="1.9" />
            <circle class="st0" cx="643" cy="218.8" r="1.9" />
            <circle class="st0" cx="643" cy="225.6" r="1.9" />
            <circle class="st0" cx="643" cy="232.4" r="1.9" />
            <circle class="st0" cx="643" cy="239.2" r="1.9" />
            <circle class="st0" cx="643" cy="252.7" r="1.9" />
            <circle class="st0" cx="643" cy="259.5" r="1.9" />
            <circle class="st0" cx="643" cy="300.2" r="1.9" />
            <circle class="st0" cx="643" cy="307" r="1.9" />
            <circle class="st0" cx="636.2" cy="56" r="1.9" />
            <circle class="st0" cx="636.2" cy="62.8" r="1.9" />
            <circle class="st0" cx="636.2" cy="69.6" r="1.9" />
            <circle class="st0" cx="636.2" cy="76.4" r="1.9" />
            <circle class="st0" cx="636.2" cy="83.2" r="1.9" />
            <circle class="st0" cx="636.2" cy="90" r="1.9" />
            <circle class="st0" cx="636.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="636.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="636.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="636.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="636.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="636.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="636.2" cy="137.4" r="1.9" />
            <circle class="st0" cx="636.2" cy="144.2" r="1.9" />
            <circle class="st0" cx="636.2" cy="151" r="1.9" />
            <circle class="st0" cx="636.2" cy="157.8" r="1.9" />
            <circle class="st0" cx="636.2" cy="164.6" r="1.9" />
            <circle class="st0" cx="636.2" cy="171.3" r="1.9" />
            <circle class="st0" cx="636.2" cy="178.1" r="1.9" />
            <circle class="st0" cx="636.2" cy="184.9" r="1.9" />
            <circle class="st0" cx="636.2" cy="191.7" r="1.9" />
            <circle class="st0" cx="636.2" cy="198.5" r="1.9" />
            <circle class="st0" cx="636.2" cy="205.3" r="1.9" />
            <circle class="st0" cx="636.2" cy="212" r="1.9" />
            <circle class="st0" cx="636.2" cy="218.8" r="1.9" />
            <circle class="st0" cx="636.2" cy="225.6" r="1.9" />
            <circle class="st0" cx="636.2" cy="232.4" r="1.9" />
            <circle class="st0" cx="636.2" cy="239.2" r="1.9" />
            <circle class="st0" cx="636.2" cy="246" r="1.9" />
            <circle class="st0" cx="636.2" cy="252.7" r="1.9" />
            <circle class="st0" cx="636.2" cy="259.5" r="1.9" />
            <circle class="st0" cx="636.2" cy="266.3" r="1.9" />
            <circle class="st0" cx="636.2" cy="279.9" r="1.9" />
            <circle class="st0" cx="636.2" cy="286.6" r="1.9" />
            <circle class="st0" cx="636.2" cy="293.4" r="1.9" />
            <circle class="st0" cx="636.2" cy="300.2" r="1.9" />
            <circle class="st0" cx="629.4" cy="56" r="1.9" />
            <circle class="st0" cx="629.4" cy="62.8" r="1.9" />
            <circle class="st0" cx="629.4" cy="69.6" r="1.9" />
            <circle class="st0" cx="629.4" cy="76.4" r="1.9" />
            <circle class="st0" cx="629.4" cy="83.2" r="1.9" />
            <circle class="st0" cx="629.4" cy="90" r="1.9" />
            <circle class="st0" cx="629.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="629.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="629.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="629.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="629.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="629.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="629.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="629.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="629.4" cy="151" r="1.9" />
            <circle class="st0" cx="629.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="629.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="629.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="629.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="629.4" cy="184.9" r="1.9" />
            <circle class="st0" cx="629.4" cy="191.7" r="1.9" />
            <circle class="st0" cx="629.4" cy="198.5" r="1.9" />
            <circle class="st0" cx="629.4" cy="205.3" r="1.9" />
            <circle class="st0" cx="629.4" cy="212" r="1.9" />
            <circle class="st0" cx="629.4" cy="218.8" r="1.9" />
            <circle class="st0" cx="629.4" cy="225.6" r="1.9" />
            <circle class="st0" cx="629.4" cy="232.4" r="1.9" />
            <circle class="st0" cx="629.4" cy="239.2" r="1.9" />
            <circle class="st0" cx="629.4" cy="246" r="1.9" />
            <circle class="st0" cx="629.4" cy="252.7" r="1.9" />
            <circle class="st0" cx="629.4" cy="259.5" r="1.9" />
            <circle class="st0" cx="629.4" cy="273.1" r="1.9" />
            <circle class="st0" cx="629.4" cy="279.9" r="1.9" />
            <circle class="st0" cx="629.4" cy="286.6" r="1.9" />
            <circle class="st0" cx="629.4" cy="293.4" r="1.9" />
            <circle class="st0" cx="622.7" cy="49.3" r="1.9" />
            <circle class="st0" cx="622.7" cy="56" r="1.9" />
            <circle class="st0" cx="622.7" cy="69.6" r="1.9" />
            <circle class="st0" cx="622.7" cy="76.4" r="1.9" />
            <circle class="st0" cx="622.7" cy="83.2" r="1.9" />
            <circle class="st0" cx="622.7" cy="90" r="1.9" />
            <circle class="st0" cx="622.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="622.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="622.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="622.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="622.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="622.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="622.7" cy="137.4" r="1.9" />
            <circle class="st0" cx="622.7" cy="144.2" r="1.9" />
            <circle class="st0" cx="622.7" cy="151" r="1.9" />
            <circle class="st0" cx="622.7" cy="157.8" r="1.9" />
            <circle class="st0" cx="622.7" cy="164.6" r="1.9" />
            <circle class="st0" cx="622.7" cy="171.3" r="1.9" />
            <circle class="st0" cx="622.7" cy="178.1" r="1.9" />
            <circle class="st0" cx="622.7" cy="184.9" r="1.9" />
            <circle class="st0" cx="622.7" cy="191.7" r="1.9" />
            <circle class="st0" cx="622.7" cy="198.5" r="1.9" />
            <circle class="st0" cx="622.7" cy="205.3" r="1.9" />
            <circle class="st0" cx="622.7" cy="212" r="1.9" />
            <circle class="st0" cx="622.7" cy="218.8" r="1.9" />
            <circle class="st0" cx="622.7" cy="225.6" r="1.9" />
            <circle class="st0" cx="622.7" cy="232.4" r="1.9" />
            <circle class="st0" cx="622.7" cy="239.2" r="1.9" />
            <circle class="st0" cx="622.7" cy="246" r="1.9" />
            <circle class="st0" cx="622.7" cy="252.7" r="1.9" />
            <circle class="st0" cx="622.7" cy="259.5" r="1.9" />
            <circle class="st0" cx="622.7" cy="266.3" r="1.9" />
            <circle class="st0" cx="622.7" cy="273.1" r="1.9" />
            <circle class="st0" cx="622.7" cy="279.9" r="1.9" />
            <circle class="st0" cx="622.7" cy="286.6" r="1.9" />
            <circle class="st0" cx="615.9" cy="42.5" r="1.9" />
            <circle class="st0" cx="615.9" cy="49.3" r="1.9" />
            <circle class="st0" cx="615.9" cy="56" r="1.9" />
            <circle class="st0" cx="615.9" cy="69.6" r="1.9" />
            <circle class="st0" cx="615.9" cy="76.4" r="1.9" />
            <circle class="st0" cx="615.9" cy="83.2" r="1.9" />
            <circle class="st0" cx="615.9" cy="90" r="1.9" />
            <circle class="st0" cx="615.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="615.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="615.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="615.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="615.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="615.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="615.9" cy="137.4" r="1.9" />
            <circle class="st0" cx="615.9" cy="144.2" r="1.9" />
            <circle class="st0" cx="615.9" cy="151" r="1.9" />
            <circle class="st0" cx="615.9" cy="157.8" r="1.9" />
            <circle class="st0" cx="615.9" cy="164.6" r="1.9" />
            <circle class="st0" cx="615.9" cy="171.3" r="1.9" />
            <circle class="st0" cx="615.9" cy="178.1" r="1.9" />
            <circle class="st0" cx="615.9" cy="184.9" r="1.9" />
            <circle class="st0" cx="615.9" cy="191.7" r="1.9" />
            <circle class="st0" cx="615.9" cy="198.5" r="1.9" />
            <circle class="st0" cx="615.9" cy="205.3" r="1.9" />
            <circle class="st0" cx="615.9" cy="212" r="1.9" />
            <circle class="st0" cx="615.9" cy="218.8" r="1.9" />
            <circle class="st0" cx="615.9" cy="225.6" r="1.9" />
            <circle class="st0" cx="615.9" cy="232.4" r="1.9" />
            <circle class="st0" cx="615.9" cy="239.2" r="1.9" />
            <circle class="st0" cx="615.9" cy="246" r="1.9" />
            <circle class="st0" cx="615.9" cy="279.9" r="1.9" />
            <circle class="st0" cx="609.1" cy="49.3" r="1.9" />
            <circle class="st0" cx="609.1" cy="69.6" r="1.9" />
            <circle class="st0" cx="609.1" cy="76.4" r="1.9" />
            <circle class="st0" cx="609.1" cy="83.2" r="1.9" />
            <circle class="st0" cx="609.1" cy="90" r="1.9" />
            <circle class="st0" cx="609.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="609.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="609.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="609.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="609.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="609.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="609.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="609.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="609.1" cy="151" r="1.9" />
            <circle class="st0" cx="609.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="609.1" cy="164.6" r="1.9" />
            <circle class="st0" cx="609.1" cy="171.3" r="1.9" />
            <circle class="st0" cx="609.1" cy="178.1" r="1.9" />
            <circle class="st0" cx="609.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="609.1" cy="191.7" r="1.9" />
            <circle class="st0" cx="609.1" cy="198.5" r="1.9" />
            <circle class="st0" cx="609.1" cy="205.3" r="1.9" />
            <circle class="st0" cx="609.1" cy="212" r="1.9" />
            <circle class="st0" cx="609.1" cy="218.8" r="1.9" />
            <circle class="st0" cx="609.1" cy="225.6" r="1.9" />
            <circle class="st0" cx="609.1" cy="232.4" r="1.9" />
            <circle class="st0" cx="609.1" cy="239.2" r="1.9" />
            <circle class="st0" cx="602.3" cy="76.4" r="1.9" />
            <circle class="st0" cx="602.3" cy="83.2" r="1.9" />
            <circle class="st0" cx="602.3" cy="90" r="1.9" />
            <circle class="st0" cx="602.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="602.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="602.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="602.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="602.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="602.3" cy="130.7" r="1.9" />
            <circle class="st0" cx="602.3" cy="137.4" r="1.9" />
            <circle class="st0" cx="602.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="602.3" cy="151" r="1.9" />
            <circle class="st0" cx="602.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="602.3" cy="164.6" r="1.9" />
            <circle class="st0" cx="602.3" cy="171.3" r="1.9" />
            <circle class="st0" cx="602.3" cy="178.1" r="1.9" />
            <circle class="st0" cx="602.3" cy="184.9" r="1.9" />
            <circle class="st0" cx="602.3" cy="191.7" r="1.9" />
            <circle class="st0" cx="602.3" cy="198.5" r="1.9" />
            <circle class="st0" cx="602.3" cy="205.3" r="1.9" />
            <circle class="st0" cx="602.3" cy="212" r="1.9" />
            <circle class="st0" cx="602.3" cy="218.8" r="1.9" />
            <circle class="st0" cx="602.3" cy="225.6" r="1.9" />
            <circle class="st0" cx="602.3" cy="232.4" r="1.9" />
            <circle class="st0" cx="602.3" cy="239.2" r="1.9" />
            <circle class="st0" cx="595.5" cy="76.4" r="1.9" />
            <circle class="st0" cx="595.5" cy="83.2" r="1.9" />
            <circle class="st0" cx="595.5" cy="90" r="1.9" />
            <circle class="st0" cx="595.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="595.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="595.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="595.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="595.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="595.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="595.5" cy="137.4" r="1.9" />
            <circle class="st0" cx="595.5" cy="144.2" r="1.9" />
            <circle class="st0" cx="595.5" cy="151" r="1.9" />
            <circle class="st0" cx="595.5" cy="157.8" r="1.9" />
            <circle class="st0" cx="595.5" cy="164.6" r="1.9" />
            <circle class="st0" cx="595.5" cy="171.3" r="1.9" />
            <circle class="st0" cx="595.5" cy="178.1" r="1.9" />
            <circle class="st0" cx="595.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="595.5" cy="191.7" r="1.9" />
            <circle class="st0" cx="595.5" cy="198.5" r="1.9" />
            <circle class="st0" cx="595.5" cy="205.3" r="1.9" />
            <circle class="st0" cx="595.5" cy="212" r="1.9" />
            <circle class="st0" cx="595.5" cy="218.8" r="1.9" />
            <circle class="st0" cx="595.5" cy="225.6" r="1.9" />
            <circle class="st0" cx="595.5" cy="232.4" r="1.9" />
            <circle class="st0" cx="595.5" cy="239.2" r="1.9" />
            <circle class="st0" cx="588.7" cy="83.2" r="1.9" />
            <circle class="st0" cx="588.7" cy="90" r="1.9" />
            <circle class="st0" cx="588.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="588.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="588.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="588.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="588.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="588.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="588.7" cy="137.4" r="1.9" />
            <circle class="st0" cx="588.7" cy="144.2" r="1.9" />
            <circle class="st0" cx="588.7" cy="151" r="1.9" />
            <circle class="st0" cx="588.7" cy="157.8" r="1.9" />
            <circle class="st0" cx="588.7" cy="164.6" r="1.9" />
            <circle class="st0" cx="588.7" cy="171.3" r="1.9" />
            <circle class="st0" cx="588.7" cy="178.1" r="1.9" />
            <circle class="st0" cx="588.7" cy="184.9" r="1.9" />
            <circle class="st0" cx="588.7" cy="191.7" r="1.9" />
            <circle class="st0" cx="588.7" cy="198.5" r="1.9" />
            <circle class="st0" cx="588.7" cy="205.3" r="1.9" />
            <circle class="st0" cx="588.7" cy="212" r="1.9" />
            <circle class="st0" cx="588.7" cy="218.8" r="1.9" />
            <circle class="st0" cx="588.7" cy="225.6" r="1.9" />
            <circle class="st0" cx="588.7" cy="232.4" r="1.9" />
            <circle class="st0" cx="588.7" cy="239.2" r="1.9" />
            <circle class="st0" cx="588.7" cy="246" r="1.9" />
            <circle class="st0" cx="582" cy="83.2" r="1.9" />
            <circle class="st0" cx="582" cy="90" r="1.9" />
            <circle class="st0" cx="582" cy="96.7" r="1.9" />
            <circle class="st0" cx="582" cy="103.5" r="1.9" />
            <circle class="st0" cx="582" cy="110.3" r="1.9" />
            <circle class="st0" cx="582" cy="117.1" r="1.9" />
            <circle class="st0" cx="582" cy="123.9" r="1.9" />
            <circle class="st0" cx="582" cy="130.7" r="1.9" />
            <circle class="st0" cx="582" cy="137.4" r="1.9" />
            <circle class="st0" cx="582" cy="144.2" r="1.9" />
            <circle class="st0" cx="582" cy="151" r="1.9" />
            <circle class="st0" cx="582" cy="157.8" r="1.9" />
            <circle class="st0" cx="582" cy="164.6" r="1.9" />
            <circle class="st0" cx="582" cy="171.3" r="1.9" />
            <circle class="st0" cx="582" cy="178.1" r="1.9" />
            <circle class="st0" cx="582" cy="184.9" r="1.9" />
            <circle class="st0" cx="582" cy="191.7" r="1.9" />
            <circle class="st0" cx="582" cy="198.5" r="1.9" />
            <circle class="st0" cx="582" cy="205.3" r="1.9" />
            <circle class="st0" cx="582" cy="212" r="1.9" />
            <circle class="st0" cx="582" cy="218.8" r="1.9" />
            <circle class="st0" cx="582" cy="225.6" r="1.9" />
            <circle class="st0" cx="582" cy="232.4" r="1.9" />
            <circle class="st0" cx="582" cy="239.2" r="1.9" />
            <circle class="st0" cx="582" cy="246" r="1.9" />
            <circle class="st0" cx="582" cy="252.7" r="1.9" />
            <circle class="st0" cx="582" cy="259.5" r="1.9" />
            <circle class="st0" cx="582" cy="273.1" r="1.9" />
            <circle class="st0" cx="575.2" cy="83.2" r="1.9" />
            <circle class="st0" cx="575.2" cy="90" r="1.9" />
            <circle class="st0" cx="575.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="575.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="575.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="575.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="575.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="575.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="575.2" cy="137.4" r="1.9" />
            <circle class="st0" cx="575.2" cy="144.2" r="1.9" />
            <circle class="st0" cx="575.2" cy="151" r="1.9" />
            <circle class="st0" cx="575.2" cy="157.8" r="1.9" />
            <circle class="st0" cx="575.2" cy="164.6" r="1.9" />
            <circle class="st0" cx="575.2" cy="171.3" r="1.9" />
            <circle class="st0" cx="575.2" cy="178.1" r="1.9" />
            <circle class="st0" cx="575.2" cy="184.9" r="1.9" />
            <circle class="st0" cx="575.2" cy="191.7" r="1.9" />
            <circle class="st0" cx="575.2" cy="198.5" r="1.9" />
            <circle class="st0" cx="575.2" cy="205.3" r="1.9" />
            <circle class="st0" cx="575.2" cy="212" r="1.9" />
            <circle class="st0" cx="575.2" cy="218.8" r="1.9" />
            <circle class="st0" cx="575.2" cy="225.6" r="1.9" />
            <circle class="st0" cx="575.2" cy="232.4" r="1.9" />
            <circle class="st0" cx="575.2" cy="239.2" r="1.9" />
            <circle class="st0" cx="575.2" cy="246" r="1.9" />
            <circle class="st0" cx="575.2" cy="252.7" r="1.9" />
            <circle class="st0" cx="575.2" cy="259.5" r="1.9" />
            <circle class="st0" cx="575.2" cy="266.3" r="1.9" />
            <circle class="st0" cx="568.4" cy="83.2" r="1.9" />
            <circle class="st0" cx="568.4" cy="90" r="1.9" />
            <circle class="st0" cx="568.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="568.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="568.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="568.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="568.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="568.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="568.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="568.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="568.4" cy="151" r="1.9" />
            <circle class="st0" cx="568.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="568.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="568.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="568.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="568.4" cy="184.9" r="1.9" />
            <circle class="st0" cx="568.4" cy="191.7" r="1.9" />
            <circle class="st0" cx="568.4" cy="198.5" r="1.9" />
            <circle class="st0" cx="568.4" cy="205.3" r="1.9" />
            <circle class="st0" cx="568.4" cy="212" r="1.9" />
            <circle class="st0" cx="568.4" cy="218.8" r="1.9" />
            <circle class="st0" cx="568.4" cy="225.6" r="1.9" />
            <circle class="st0" cx="568.4" cy="232.4" r="1.9" />
            <circle class="st0" cx="568.4" cy="239.2" r="1.9" />
            <circle class="st0" cx="568.4" cy="246" r="1.9" />
            <circle class="st0" cx="568.4" cy="252.7" r="1.9" />
            <circle class="st0" cx="568.4" cy="259.5" r="1.9" />
            <circle class="st0" cx="561.6" cy="83.2" r="1.9" />
            <circle class="st0" cx="561.6" cy="90" r="1.9" />
            <circle class="st0" cx="561.6" cy="96.7" r="1.9" />
            <circle class="st0" cx="561.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="561.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="561.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="561.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="561.6" cy="130.7" r="1.9" />
            <circle class="st0" cx="561.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="561.6" cy="144.2" r="1.9" />
            <circle class="st0" cx="561.6" cy="151" r="1.9" />
            <circle class="st0" cx="561.6" cy="157.8" r="1.9" />
            <circle class="st0" cx="561.6" cy="164.6" r="1.9" />
            <circle class="st0" cx="561.6" cy="171.3" r="1.9" />
            <circle class="st0" cx="561.6" cy="178.1" r="1.9" />
            <circle class="st0" cx="561.6" cy="184.9" r="1.9" />
            <circle class="st0" cx="561.6" cy="191.7" r="1.9" />
            <circle class="st0" cx="561.6" cy="198.5" r="1.9" />
            <circle class="st0" cx="561.6" cy="205.3" r="1.9" />
            <circle class="st0" cx="561.6" cy="212" r="1.9" />
            <circle class="st0" cx="561.6" cy="218.8" r="1.9" />
            <circle class="st0" cx="561.6" cy="225.6" r="1.9" />
            <circle class="st0" cx="561.6" cy="232.4" r="1.9" />
            <circle class="st0" cx="561.6" cy="239.2" r="1.9" />
            <circle class="st0" cx="554.8" cy="69.6" r="1.9" />
            <circle class="st0" cx="554.8" cy="83.2" r="1.9" />
            <circle class="st0" cx="554.8" cy="90" r="1.9" />
            <circle class="st0" cx="554.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="541.3" cy="49.3" r="1.9" />
            <circle class="st0" cx="548.1" cy="49.3" r="1.9" />
            <circle class="st0" cx="534.5" cy="42.5" r="1.9" />
            <circle class="st0" cx="534.5" cy="49.3" r="1.9" />
            <circle class="st0" cx="527.7" cy="42.5" r="1.9" />
            <circle class="st0" cx="527.7" cy="49.3" r="1.9" />
            <circle class="st0" cx="520.9" cy="49.3" r="1.9" />
            <circle class="st0" cx="507.4" cy="49.3" r="1.9" />
            <circle class="st0" cx="500.6" cy="42.5" r="1.9" />
            <circle class="st0" cx="500.6" cy="49.3" r="1.9" />
            <circle class="st0" cx="493.8" cy="42.5" r="1.9" />
            <circle class="st0" cx="554.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="554.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="554.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="554.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="554.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="554.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="554.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="554.8" cy="151" r="1.9" />
            <circle class="st0" cx="554.8" cy="157.8" r="1.9" />
            <circle class="st0" cx="554.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="554.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="554.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="554.8" cy="184.9" r="1.9" />
            <circle class="st0" cx="554.8" cy="191.7" r="1.9" />
            <circle class="st0" cx="554.8" cy="198.5" r="1.9" />
            <circle class="st0" cx="554.8" cy="205.3" r="1.9" />
            <circle class="st0" cx="554.8" cy="212" r="1.9" />
            <circle class="st0" cx="554.8" cy="218.8" r="1.9" />
            <circle class="st0" cx="554.8" cy="225.6" r="1.9" />
            <circle class="st0" cx="554.8" cy="232.4" r="1.9" />
            <circle class="st0" cx="554.8" cy="239.2" r="1.9" />
            <circle class="st0" cx="548.1" cy="69.6" r="1.9" />
            <circle class="st0" cx="548.1" cy="90" r="1.9" />
            <circle class="st0" cx="548.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="548.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="548.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="548.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="548.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="548.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="548.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="548.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="548.1" cy="151" r="1.9" />
            <circle class="st0" cx="548.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="548.1" cy="164.6" r="1.9" />
            <circle class="st0" cx="548.1" cy="171.3" r="1.9" />
            <circle class="st0" cx="548.1" cy="178.1" r="1.9" />
            <circle class="st0" cx="548.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="548.1" cy="191.7" r="1.9" />
            <circle class="st0" cx="548.1" cy="198.5" r="1.9" />
            <circle class="st0" cx="548.1" cy="205.3" r="1.9" />
            <circle class="st0" cx="548.1" cy="212" r="1.9" />
            <circle class="st0" cx="548.1" cy="218.8" r="1.9" />
            <circle class="st0" cx="548.1" cy="225.6" r="1.9" />
            <circle class="st0" cx="541.3" cy="69.6" r="1.9" />
            <circle class="st0" cx="541.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="541.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="541.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="541.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="541.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="541.3" cy="130.7" r="1.9" />
            <circle class="st0" cx="541.3" cy="137.4" r="1.9" />
            <circle class="st0" cx="541.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="541.3" cy="151" r="1.9" />
            <circle class="st0" cx="541.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="541.3" cy="164.6" r="1.9" />
            <circle class="st0" cx="541.3" cy="171.3" r="1.9" />
            <circle class="st0" cx="541.3" cy="178.1" r="1.9" />
            <circle class="st0" cx="541.3" cy="184.9" r="1.9" />
            <circle class="st0" cx="541.3" cy="191.7" r="1.9" />
            <circle class="st0" cx="541.3" cy="198.5" r="1.9" />
            <circle class="st0" cx="541.3" cy="205.3" r="1.9" />
            <circle class="st0" cx="541.3" cy="212" r="1.9" />
            <circle class="st0" cx="541.3" cy="218.8" r="1.9" />
            <circle class="st0" cx="541.3" cy="225.6" r="1.9" />
            <circle class="st0" cx="534.5" cy="69.6" r="1.9" />
            <circle class="st0" cx="534.5" cy="76.4" r="1.9" />
            <circle class="st0" cx="534.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="534.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="534.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="534.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="534.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="534.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="534.5" cy="137.4" r="1.9" />
            <circle class="st0" cx="534.5" cy="144.2" r="1.9" />
            <circle class="st0" cx="534.5" cy="151" r="1.9" />
            <circle class="st0" cx="534.5" cy="157.8" r="1.9" />
            <circle class="st0" cx="534.5" cy="164.6" r="1.9" />
            <circle class="st0" cx="534.5" cy="171.3" r="1.9" />
            <circle class="st0" cx="534.5" cy="178.1" r="1.9" />
            <circle class="st0" cx="534.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="534.5" cy="191.7" r="1.9" />
            <circle class="st0" cx="534.5" cy="198.5" r="1.9" />
            <circle class="st0" cx="534.5" cy="205.3" r="1.9" />
            <circle class="st0" cx="534.5" cy="212" r="1.9" />
            <circle class="st0" cx="534.5" cy="218.8" r="1.9" />
            <circle class="st0" cx="534.5" cy="225.6" r="1.9" />
            <circle class="st0" cx="527.7" cy="76.4" r="1.9" />
            <circle class="st0" cx="527.7" cy="83.2" r="1.9" />
            <circle class="st0" cx="527.7" cy="90" r="1.9" />
            <circle class="st0" cx="527.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="527.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="527.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="527.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="527.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="527.7" cy="137.4" r="1.9" />
            <circle class="st0" cx="527.7" cy="144.2" r="1.9" />
            <circle class="st0" cx="527.7" cy="151" r="1.9" />
            <circle class="st0" cx="527.7" cy="157.8" r="1.9" />
            <circle class="st0" cx="527.7" cy="164.6" r="1.9" />
            <circle class="st0" cx="527.7" cy="171.3" r="1.9" />
            <circle class="st0" cx="527.7" cy="178.1" r="1.9" />
            <circle class="st0" cx="527.7" cy="184.9" r="1.9" />
            <circle class="st0" cx="527.7" cy="191.7" r="1.9" />
            <circle class="st0" cx="527.7" cy="198.5" r="1.9" />
            <circle class="st0" cx="527.7" cy="205.3" r="1.9" />
            <circle class="st0" cx="527.7" cy="212" r="1.9" />
            <circle class="st0" cx="527.7" cy="218.8" r="1.9" />
            <circle class="st0" cx="527.7" cy="225.6" r="1.9" />
            <circle class="st0" cx="527.7" cy="239.2" r="1.9" />
            <circle class="st0" cx="520.9" cy="83.2" r="1.9" />
            <circle class="st0" cx="520.9" cy="90" r="1.9" />
            <circle class="st0" cx="520.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="520.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="520.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="520.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="520.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="520.9" cy="137.4" r="1.9" />
            <circle class="st0" cx="520.9" cy="144.2" r="1.9" />
            <circle class="st0" cx="520.9" cy="151" r="1.9" />
            <circle class="st0" cx="520.9" cy="157.8" r="1.9" />
            <circle class="st0" cx="520.9" cy="164.6" r="1.9" />
            <circle class="st0" cx="520.9" cy="171.3" r="1.9" />
            <circle class="st0" cx="520.9" cy="178.1" r="1.9" />
            <circle class="st0" cx="520.9" cy="184.9" r="1.9" />
            <circle class="st0" cx="520.9" cy="191.7" r="1.9" />
            <circle class="st0" cx="520.9" cy="198.5" r="1.9" />
            <circle class="st0" cx="520.9" cy="205.3" r="1.9" />
            <circle class="st0" cx="520.9" cy="212" r="1.9" />
            <circle class="st0" cx="520.9" cy="218.8" r="1.9" />
            <circle class="st0" cx="520.9" cy="225.6" r="1.9" />
            <circle class="st0" cx="520.9" cy="239.2" r="1.9" />
            <circle class="st0" cx="520.9" cy="246" r="1.9" />
            <circle class="st0" cx="514.1" cy="90" r="1.9" />
            <circle class="st0" cx="514.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="514.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="514.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="514.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="514.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="514.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="514.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="514.1" cy="151" r="1.9" />
            <circle class="st0" cx="514.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="514.1" cy="164.6" r="1.9" />
            <circle class="st0" cx="514.1" cy="171.3" r="1.9" />
            <circle class="st0" cx="514.1" cy="178.1" r="1.9" />
            <circle class="st0" cx="514.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="514.1" cy="191.7" r="1.9" />
            <circle class="st0" cx="514.1" cy="198.5" r="1.9" />
            <circle class="st0" cx="514.1" cy="205.3" r="1.9" />
            <circle class="st0" cx="514.1" cy="212" r="1.9" />
            <circle class="st0" cx="514.1" cy="218.8" r="1.9" />
            <circle class="st0" cx="514.1" cy="232.4" r="1.9" />
            <circle class="st0" cx="514.1" cy="239.2" r="1.9" />
            <circle class="st0" cx="514.1" cy="246" r="1.9" />
            <circle class="st0" cx="514.1" cy="252.7" r="1.9" />
            <circle class="st0" cx="514.1" cy="266.3" r="1.9" />
            <circle class="st0" cx="514.1" cy="273.1" r="1.9" />
            <circle class="st0" cx="514.1" cy="320.6" r="1.9" />
            <circle class="st0" cx="507.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="507.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="507.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="507.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="507.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="507.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="507.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="507.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="507.4" cy="151" r="1.9" />
            <circle class="st0" cx="507.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="507.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="507.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="507.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="507.4" cy="184.9" r="1.9" />
            <circle class="st0" cx="507.4" cy="191.7" r="1.9" />
            <circle class="st0" cx="507.4" cy="198.5" r="1.9" />
            <circle class="st0" cx="507.4" cy="205.3" r="1.9" />
            <circle class="st0" cx="507.4" cy="212" r="1.9" />
            <circle class="st0" cx="507.4" cy="218.8" r="1.9" />
            <circle class="st0" cx="507.4" cy="225.6" r="1.9" />
            <circle class="st0" cx="507.4" cy="232.4" r="1.9" />
            <circle class="st0" cx="507.4" cy="239.2" r="1.9" />
            <circle class="st0" cx="507.4" cy="246" r="1.9" />
            <circle class="st0" cx="507.4" cy="252.7" r="1.9" />
            <circle class="st0" cx="507.4" cy="266.3" r="1.9" />
            <circle class="st0" cx="507.4" cy="273.1" r="1.9" />
            <circle class="st0" cx="507.4" cy="320.6" r="1.9" />
            <circle class="st0" cx="507.4" cy="327.3" r="1.9" />
            <circle class="st0" cx="507.4" cy="334.1" r="1.9" />
            <circle class="st0" cx="507.4" cy="340.9" r="1.9" />
            <circle class="st0" cx="500.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="500.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="500.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="500.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="500.6" cy="130.7" r="1.9" />
            <circle class="st0" cx="500.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="500.6" cy="144.2" r="1.9" />
            <circle class="st0" cx="500.6" cy="151" r="1.9" />
            <circle class="st0" cx="500.6" cy="157.8" r="1.9" />
            <circle class="st0" cx="500.6" cy="164.6" r="1.9" />
            <circle class="st0" cx="500.6" cy="171.3" r="1.9" />
            <circle class="st0" cx="500.6" cy="178.1" r="1.9" />
            <circle class="st0" cx="500.6" cy="184.9" r="1.9" />
            <circle class="st0" cx="405.6" cy="157.8" r="1.9" />
            <circle class="st0" cx="398.8" cy="151" r="1.9" />
            <circle class="st0" cx="392.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="398.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="392.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="392.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="392.1" cy="151" r="1.9" />
            <circle class="st0" cx="392.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="385.3" cy="137.4" r="1.9" />
            <circle class="st0" cx="385.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="385.3" cy="151" r="1.9" />
            <circle class="st0" cx="385.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="378.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="378.5" cy="144.2" r="1.9" />
            <circle class="st0" cx="378.5" cy="151" r="1.9" />
            <circle class="st0" cx="371.7" cy="151" r="1.9" />
            <circle class="st0" cx="500.6" cy="191.7" r="1.9" />
            <circle class="st0" cx="500.6" cy="198.5" r="1.9" />
            <circle class="st0" cx="500.6" cy="205.3" r="1.9" />
            <circle class="st0" cx="500.6" cy="212" r="1.9" />
            <circle class="st0" cx="500.6" cy="218.8" r="1.9" />
            <circle class="st0" cx="500.6" cy="225.6" r="1.9" />
            <circle class="st0" cx="500.6" cy="232.4" r="1.9" />
            <circle class="st0" cx="500.6" cy="239.2" r="1.9" />
            <circle class="st0" cx="500.6" cy="246" r="1.9" />
            <circle class="st0" cx="500.6" cy="252.7" r="1.9" />
            <circle class="st0" cx="500.6" cy="259.5" r="1.9" />
            <circle class="st0" cx="500.6" cy="266.3" r="1.9" />
            <circle class="st0" cx="500.6" cy="273.1" r="1.9" />
            <circle class="st0" cx="500.6" cy="279.9" r="1.9" />
            <circle class="st0" cx="500.6" cy="327.3" r="1.9" />
            <circle class="st0" cx="500.6" cy="334.1" r="1.9" />
            <circle class="st0" cx="500.6" cy="340.9" r="1.9" />
            <circle class="st0" cx="500.6" cy="347.7" r="1.9" />
            <circle class="st0" cx="493.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="493.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="493.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="493.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="493.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="493.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="493.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="493.8" cy="151" r="1.9" />
            <circle class="st0" cx="493.8" cy="157.8" r="1.9" />
            <circle class="st0" cx="493.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="493.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="493.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="493.8" cy="184.9" r="1.9" />
            <circle class="st0" cx="493.8" cy="191.7" r="1.9" />
            <circle class="st0" cx="493.8" cy="198.5" r="1.9" />
            <circle class="st0" cx="493.8" cy="205.3" r="1.9" />
            <circle class="st0" cx="493.8" cy="212" r="1.9" />
            <circle class="st0" cx="493.8" cy="218.8" r="1.9" />
            <circle class="st0" cx="493.8" cy="225.6" r="1.9" />
            <circle class="st0" cx="493.8" cy="232.4" r="1.9" />
            <circle class="st0" cx="493.8" cy="239.2" r="1.9" />
            <circle class="st0" cx="493.8" cy="246" r="1.9" />
            <circle class="st0" cx="493.8" cy="259.5" r="1.9" />
            <circle class="st0" cx="493.8" cy="266.3" r="1.9" />
            <circle class="st0" cx="493.8" cy="273.1" r="1.9" />
            <circle class="st0" cx="493.8" cy="279.9" r="1.9" />
            <circle class="st0" cx="493.8" cy="286.6" r="1.9" />
            <circle class="st0" cx="487" cy="103.5" r="1.9" />
            <circle class="st0" cx="487" cy="110.3" r="1.9" />
            <circle class="st0" cx="487" cy="117.1" r="1.9" />
            <circle class="st0" cx="487" cy="123.9" r="1.9" />
            <circle class="st0" cx="487" cy="130.7" r="1.9" />
            <circle class="st0" cx="487" cy="137.4" r="1.9" />
            <circle class="st0" cx="487" cy="144.2" r="1.9" />
            <circle class="st0" cx="487" cy="151" r="1.9" />
            <circle class="st0" cx="487" cy="157.8" r="1.9" />
            <circle class="st0" cx="487" cy="164.6" r="1.9" />
            <circle class="st0" cx="487" cy="171.3" r="1.9" />
            <circle class="st0" cx="487" cy="178.1" r="1.9" />
            <circle class="st0" cx="487" cy="191.7" r="1.9" />
            <circle class="st0" cx="487" cy="198.5" r="1.9" />
            <circle class="st0" cx="487" cy="205.3" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Israel')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Israel, 'fill-[#cbd1d926]': !reviewSections.Israel }" cx="487"
                class="cursor-pointer" cy="212" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Israel')" cx="487"
                :class="{ 'fill-mainColor': reviewSections.Israel, 'fill-[#5F6177]': !reviewSections.Israel }"
                class="cursor-pointer" cy="212" r="2.5" />
            <circle class="st0" cx="487" cy="218.8" r="1.9" />
            <circle class="st0" cx="487" cy="225.6" r="1.9" />
            <circle class="st0" cx="487" cy="232.4" r="1.9" />
            <circle class="st0" cx="487" cy="239.2" r="1.9" />
            <circle class="st0" cx="487" cy="252.7" r="1.9" />
            <circle class="st0" cx="487" cy="259.5" r="1.9" />
            <circle class="st0" cx="487" cy="266.3" r="1.9" />
            <circle class="st0" cx="487" cy="273.1" r="1.9" />
            <circle class="st0" cx="487" cy="279.9" r="1.9" />
            <circle class="st0" cx="487" cy="286.6" r="1.9" />
            <circle class="st0" cx="487" cy="293.4" r="1.9" />
            <circle class="st0" cx="487" cy="300.2" r="1.9" />
            <circle class="st0" cx="487" cy="307" r="1.9" />
            <circle class="st0" cx="487" cy="313.8" r="1.9" />
            <circle class="st0" cx="487" cy="320.6" r="1.9" />
            <circle class="st0" cx="487" cy="327.3" r="1.9" />
            <circle class="st0" cx="480.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="480.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="480.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="480.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="480.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="480.2" cy="137.4" r="1.9" />
            <circle class="st0" cx="480.2" cy="144.2" r="1.9" />
            <circle class="st0" cx="480.2" cy="151" r="1.9" />
            <circle class="st0" cx="480.2" cy="157.8" r="1.9" />
            <circle class="st0" cx="358.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="351.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="351.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="344.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="344.6" cy="117.1" r="1.9" />
            <circle class="st1" cx="480.2" cy="164.6" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Lviv')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Lviv, 'fill-[#cbd1d926]': !reviewSections.Lviv }" cx="480.2"
                class="cursor-pointer" cy="164.6" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Lviv')" cx="480.2"
                :class="{ 'fill-mainColor': reviewSections.Lviv, 'fill-[#5F6177]': !reviewSections.Lviv }"
                class="cursor-pointer" cy="164.6" r="2.5" />
            <circle class="st0" cx="480.2" cy="171.3" r="1.9" />
            <circle class="st0" cx="480.2" cy="178.1" r="1.9" />
            <circle class="st0" cx="480.2" cy="191.7" r="1.9" />
            <circle class="st0" cx="480.2" cy="198.5" r="1.9" />
            <circle class="st0" cx="480.2" cy="205.3" r="1.9" />
            <circle @mouseenter="toggleReviewSection('IsraelQiryat')"
                :class="{ 'fill-[#FD833F40]': reviewSections.IsraelQiryat, 'fill-[#cbd1d926]': !reviewSections.IsraelQiryat }"
                cx="480.2" class="cursor-pointer" cy="212" r="8.9" />
            <circle @mouseenter="toggleReviewSection('IsraelQiryat')" cx="480.2"
                :class="{ 'fill-mainColor': reviewSections.IsraelQiryat, 'fill-[#5F6177]': !reviewSections.IsraelQiryat }"
                class="cursor-pointer" cy="212" r="2.5" />
            <circle class="st0" cx="480.2" cy="218.8" r="1.9" />
            <circle class="st0" cx="480.2" cy="225.6" r="1.9" />
            <circle class="st0" cx="480.2" cy="239.2" r="1.9" />
            <circle class="st0" cx="480.2" cy="246" r="1.9" />
            <circle class="st0" cx="480.2" cy="252.7" r="1.9" />
            <circle class="st0" cx="480.2" cy="259.5" r="1.9" />
            <circle class="st0" cx="480.2" cy="266.3" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Ethiopia')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Ethiopia, 'fill-[#cbd1d926]': !reviewSections.Ethiopia }"
                cx="480.2" class="cursor-pointer" cy="273.1" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Ethiopia')" cx="480.2"
                :class="{ 'fill-mainColor': reviewSections.Ethiopia, 'fill-[#5F6177]': !reviewSections.Ethiopia }"
                class="cursor-pointer" cy="273.1" r="2.5" />
            <circle class="st0" cx="480.2" cy="279.9" r="1.9" />
            <circle class="st0" cx="480.2" cy="286.6" r="1.9" />
            <circle class="st0" cx="480.2" cy="293.4" r="1.9" />
            <circle class="st0" cx="480.2" cy="300.2" r="1.9" />
            <circle class="st0" cx="480.2" cy="307" r="1.9" />
            <circle class="st0" cx="480.2" cy="313.8" r="1.9" />
            <circle class="st0" cx="480.2" cy="320.6" r="1.9" />
            <circle class="st0" cx="480.2" cy="327.3" r="1.9" />
            <circle class="st0" cx="480.2" cy="334.1" r="1.9" />
            <circle class="st0" cx="480.2" cy="340.9" r="1.9" />
            <circle class="st0" cx="480.2" cy="347.7" r="1.9" />
            <circle class="st0" cx="473.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="473.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="473.4" cy="117.1" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Estonia')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Estonia, 'fill-[#cbd1d926]': !reviewSections.Estonia }"
                cx="473.4" class="cursor-pointer" cy="123.9" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Estonia')" cx="473.4"
                :class="{ 'fill-mainColor': reviewSections.Estonia, 'fill-[#5F6177]': !reviewSections.Estonia }"
                class="cursor-pointer" cy="123.9" r="2.5" />
            <circle class="st0" cx="473.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="473.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="473.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="473.4" cy="151" r="1.9" />
            <circle class="st0" cx="473.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="473.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="473.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="473.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="473.4" cy="191.7" r="1.9" />
            <circle class="st0" cx="473.4" cy="198.5" r="1.9" />
            <circle class="st0" cx="473.4" cy="205.3" r="1.9" />
            <circle class="st0" cx="473.4" cy="218.8" r="1.9" />
            <circle class="st0" cx="473.4" cy="225.6" r="1.9" />
            <circle class="st0" cx="473.4" cy="232.4" r="1.9" />
            <circle class="st0" cx="473.4" cy="239.2" r="1.9" />
            <circle class="st0" cx="473.4" cy="246" r="1.9" />
            <circle class="st0" cx="473.4" cy="252.7" r="1.9" />
            <circle class="st0" cx="473.4" cy="259.5" r="1.9" />
            <circle class="st0" cx="473.4" cy="266.3" r="1.9" />
            <circle class="st0" cx="473.4" cy="273.1" r="1.9" />
            <circle class="st0" cx="473.4" cy="279.9" r="1.9" />
            <circle class="st0" cx="473.4" cy="286.6" r="1.9" />
            <circle class="st0" cx="473.4" cy="293.4" r="1.9" />
            <circle class="st0" cx="473.4" cy="300.2" r="1.9" />
            <circle class="st0" cx="473.4" cy="307" r="1.9" />
            <circle class="st0" cx="473.4" cy="313.8" r="1.9" />
            <circle class="st0" cx="473.4" cy="320.6" r="1.9" />
            <circle class="st0" cx="473.4" cy="327.3" r="1.9" />
            <circle class="st0" cx="473.4" cy="334.1" r="1.9" />
            <circle class="st0" cx="473.4" cy="340.9" r="1.9" />
            <circle class="st0" cx="473.4" cy="347.7" r="1.9" />
            <circle class="st0" cx="466.7" cy="90" r="1.9" />
            <circle class="st0" cx="466.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="466.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="466.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="466.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="466.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="466.7" cy="130.7" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Lithuania')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Lithuania, 'fill-[#cbd1d926]': !reviewSections.Lithuania }"
                cx="466.7" class="cursor-pointer" cy="137.4" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Lithuania')" cx="466.7"
                :class="{ 'fill-mainColor': reviewSections.Lithuania, 'fill-[#5F6177]': !reviewSections.Lithuania }"
                class="cursor-pointer" cy="137.4" r="2.5" />
            <circle class="st0" cx="466.7" cy="144.2" r="1.9" />
            <circle class="st0" cx="466.7" cy="151" r="1.9" />
            <circle class="st0" cx="466.7" cy="157.8" r="1.9" />
            <circle class="st0" cx="466.7" cy="164.6" r="1.9" />
            <circle class="st0" cx="466.7" cy="171.3" r="1.9" />
            <circle class="st0" cx="466.7" cy="178.1" r="1.9" />
            <circle class="st0" cx="466.7" cy="191.7" r="1.9" />
            <circle class="st0" cx="466.7" cy="198.5" r="1.9" />
            <circle class="st0" cx="466.7" cy="218.8" r="1.9" />
            <circle class="st0" cx="466.7" cy="225.6" r="1.9" />
            <circle class="st0" cx="466.7" cy="232.4" r="1.9" />
            <circle class="st0" cx="466.7" cy="239.2" r="1.9" />
            <circle class="st0" cx="466.7" cy="246" r="1.9" />
            <circle class="st0" cx="466.7" cy="252.7" r="1.9" />
            <circle class="st0" cx="466.7" cy="259.5" r="1.9" />
            <circle class="st0" cx="466.7" cy="266.3" r="1.9" />
            <circle class="st0" cx="466.7" cy="273.1" r="1.9" />
            <circle class="st0" cx="466.7" cy="279.9" r="1.9" />
            <circle class="st0" cx="466.7" cy="286.6" r="1.9" />
            <circle class="st0" cx="466.7" cy="293.4" r="1.9" />
            <circle class="st0" cx="466.7" cy="300.2" r="1.9" />
            <circle class="st0" cx="466.7" cy="307" r="1.9" />
            <circle class="st0" cx="466.7" cy="313.8" r="1.9" />
            <circle class="st0" cx="466.7" cy="320.6" r="1.9" />
            <circle class="st0" cx="466.7" cy="327.3" r="1.9" />
            <circle class="st0" cx="466.7" cy="334.1" r="1.9" />
            <circle class="st0" cx="466.7" cy="340.9" r="1.9" />
            <circle class="st0" cx="466.7" cy="347.7" r="1.9" />
            <circle class="st0" cx="466.7" cy="354.5" r="1.9" />
            <circle class="st0" cx="466.7" cy="361.3" r="1.9" />
            <circle class="st0" cx="459.9" cy="49.3" r="1.9" />
            <circle class="st0" cx="459.9" cy="90" r="1.9" />
            <circle class="st0" cx="459.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="459.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="459.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="459.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="459.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="459.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="459.9" cy="137.4" r="1.9" />
            <circle class="st0" cx="459.9" cy="144.2" r="1.9" />
            <circle class="st0" cx="459.9" cy="151" r="1.9" />
            <circle class="st0" cx="459.9" cy="157.8" r="1.9" />
            <circle class="st0" cx="459.9" cy="164.6" r="1.9" />
            <circle class="st0" cx="459.9" cy="171.3" r="1.9" />
            <circle class="st0" cx="459.9" cy="178.1" r="1.9" />
            <circle class="st0" cx="459.9" cy="184.9" r="1.9" />
            <circle class="st0" cx="459.9" cy="191.7" r="1.9" />
            <circle class="st0" cx="459.9" cy="198.5" r="1.9" />
            <circle class="st0" cx="459.9" cy="218.8" r="1.9" />
            <circle class="st0" cx="459.9" cy="225.6" r="1.9" />
            <circle class="st0" cx="459.9" cy="232.4" r="1.9" />
            <circle class="st0" cx="459.9" cy="239.2" r="1.9" />
            <circle class="st0" cx="459.9" cy="246" r="1.9" />
            <circle class="st0" cx="459.9" cy="252.7" r="1.9" />
            <circle class="st0" cx="459.9" cy="259.5" r="1.9" />
            <circle class="st0" cx="459.9" cy="266.3" r="1.9" />
            <circle class="st0" cx="459.9" cy="273.1" r="1.9" />
            <circle class="st0" cx="459.9" cy="279.9" r="1.9" />
            <circle class="st0" cx="459.9" cy="286.6" r="1.9" />
            <circle class="st0" cx="459.9" cy="293.4" r="1.9" />
            <circle class="st0" cx="459.9" cy="300.2" r="1.9" />
            <circle class="st0" cx="459.9" cy="307" r="1.9" />
            <circle class="st0" cx="459.9" cy="313.8" r="1.9" />
            <circle class="st0" cx="459.9" cy="320.6" r="1.9" />
            <circle class="st0" cx="459.9" cy="327.3" r="1.9" />
            <circle class="st0" cx="459.9" cy="334.1" r="1.9" />
            <circle class="st0" cx="459.9" cy="340.9" r="1.9" />
            <circle class="st0" cx="459.9" cy="347.7" r="1.9" />
            <circle class="st0" cx="459.9" cy="354.5" r="1.9" />
            <circle class="st0" cx="459.9" cy="361.3" r="1.9" />
            <circle class="st0" cx="459.9" cy="368" r="1.9" />
            <circle class="st0" cx="453.1" cy="49.3" r="1.9" />
            <circle class="st0" cx="453.1" cy="62.8" r="1.9" />
            <circle class="st0" cx="453.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="453.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="453.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="453.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="453.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="453.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="453.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="453.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="453.1" cy="151" r="1.9" />
            <circle class="st0" cx="453.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="453.1" cy="164.6" r="1.9" />
            <circle class="st0" cx="453.1" cy="171.3" r="1.9" />
            <circle class="st0" cx="453.1" cy="178.1" r="1.9" />
            <circle class="st0" cx="453.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="453.1" cy="191.7" r="1.9" />
            <circle class="st0" cx="453.1" cy="198.5" r="1.9" />
            <circle class="st0" cx="453.1" cy="212" r="1.9" />
            <circle class="st0" cx="453.1" cy="218.8" r="1.9" />
            <circle class="st0" cx="453.1" cy="225.6" r="1.9" />
            <circle class="st0" cx="453.1" cy="232.4" r="1.9" />
            <circle class="st0" cx="453.1" cy="239.2" r="1.9" />
            <circle class="st0" cx="453.1" cy="246" r="1.9" />
            <circle class="st0" cx="453.1" cy="252.7" r="1.9" />
            <circle class="st0" cx="453.1" cy="259.5" r="1.9" />
            <circle class="st0" cx="453.1" cy="266.3" r="1.9" />
            <circle class="st0" cx="453.1" cy="273.1" r="1.9" />
            <circle class="st0" cx="453.1" cy="279.9" r="1.9" />
            <circle class="st0" cx="453.1" cy="286.6" r="1.9" />
            <circle class="st0" cx="453.1" cy="293.4" r="1.9" />
            <circle class="st0" cx="453.1" cy="300.2" r="1.9" />
            <circle class="st0" cx="453.1" cy="307" r="1.9" />
            <circle class="st0" cx="453.1" cy="313.8" r="1.9" />
            <circle class="st0" cx="453.1" cy="320.6" r="1.9" />
            <circle class="st0" cx="453.1" cy="327.3" r="1.9" />
            <circle class="st0" cx="453.1" cy="334.1" r="1.9" />
            <circle class="st0" cx="453.1" cy="340.9" r="1.9" />
            <circle class="st0" cx="453.1" cy="347.7" r="1.9" />
            <circle @mouseenter="toggleReviewSection('SouthAfrica')"
                :class="{ 'fill-[#FD833F40]': reviewSections.SouthAfrica, 'fill-[#cbd1d926]': !reviewSections.SouthAfrica }"
                cx="453.1" class="cursor-pointer" cy="354.5" r="8.9" />
            <circle @mouseenter="toggleReviewSection('SouthAfrica')" cx="453.1"
                :class="{ 'fill-mainColor': reviewSections.SouthAfrica, 'fill-[#5F6177]': !reviewSections.SouthAfrica }"
                class="cursor-pointer" cy="354.5" r="2.5" />
            <circle class="st0" cx="453.1" cy="361.3" r="1.9" />
            <circle class="st0" cx="453.1" cy="368" r="1.9" />
            <circle class="st0" cx="446.3" cy="49.3" r="1.9" />
            <circle class="st0" cx="446.3" cy="56" r="1.9" />
            <circle class="st0" cx="446.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="446.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="446.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="446.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="446.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="446.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="446.3" cy="151" r="1.9" />
            <circle class="st0" cx="446.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="446.3" cy="164.6" r="1.9" />
            <circle class="st1" cx="446.3" cy="171.3" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Hungary')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Hungary, 'fill-[#cbd1d926]': !reviewSections.Hungary }"
                cx="446.2" class="cursor-pointer" cy="171.3" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Hungary')" cx="446.2"
                :class="{ 'fill-mainColor': reviewSections.Hungary, 'fill-[#5F6177]': !reviewSections.Hungary }"
                class="cursor-pointer" cy="171.3" r="2.5" />
            <circle class="st0" cx="446.3" cy="178.1" r="1.9" />
            <circle class="st0" cx="446.3" cy="184.9" r="1.9" />
            <circle class="st0" cx="446.3" cy="191.7" r="1.9" />
            <circle class="st0" cx="446.3" cy="198.5" r="1.9" />
            <circle class="st0" cx="446.3" cy="212" r="1.9" />
            <circle class="st0" cx="446.3" cy="218.8" r="1.9" />
            <circle class="st0" cx="446.3" cy="225.6" r="1.9" />
            <circle class="st0" cx="446.3" cy="232.4" r="1.9" />
            <circle class="st0" cx="446.3" cy="239.2" r="1.9" />
            <circle class="st0" cx="446.3" cy="246" r="1.9" />
            <circle class="st0" cx="446.3" cy="252.7" r="1.9" />
            <circle class="st0" cx="446.3" cy="259.5" r="1.9" />
            <circle class="st0" cx="446.3" cy="266.3" r="1.9" />
            <circle class="st0" cx="446.3" cy="273.1" r="1.9" />
            <circle class="st0" cx="446.3" cy="279.9" r="1.9" />
            <circle class="st0" cx="446.3" cy="286.6" r="1.9" />
            <circle class="st0" cx="446.3" cy="293.4" r="1.9" />
            <circle class="st0" cx="446.3" cy="300.2" r="1.9" />
            <circle class="st0" cx="446.3" cy="307" r="1.9" />
            <circle class="st0" cx="446.3" cy="313.8" r="1.9" />
            <circle class="st0" cx="446.3" cy="320.6" r="1.9" />
            <circle class="st0" cx="446.3" cy="327.3" r="1.9" />
            <circle class="st0" cx="446.3" cy="334.1" r="1.9" />
            <circle class="st0" cx="446.3" cy="340.9" r="1.9" />
            <circle class="st0" cx="446.3" cy="347.7" r="1.9" />
            <circle class="st0" cx="446.3" cy="354.5" r="1.9" />
            <circle class="st0" cx="446.3" cy="361.3" r="1.9" />
            <circle class="st0" cx="446.3" cy="368" r="1.9" />
            <circle class="st0" cx="439.5" cy="49.3" r="1.9" />
            <circle class="st0" cx="439.5" cy="56" r="1.9" />
            <circle class="st0" cx="439.5" cy="62.8" r="1.9" />
            <circle class="st0" cx="439.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="439.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="439.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="439.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="439.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="439.5" cy="151" r="1.9" />
            <circle @mouseenter="toggleReviewSection('GermanyMinden')"
                :class="{ 'fill-[#FD833F40]': reviewSections.GermanyMinden, 'fill-[#cbd1d926]': !reviewSections.GermanyMinden }"
                cx="439.5" class="cursor-pointer" cy="157.8" r="8.9" />
            <circle @mouseenter="toggleReviewSection('GermanyMinden')" cx="439.5"
                :class="{ 'fill-mainColor': reviewSections.GermanyMinden, 'fill-[#5F6177]': !reviewSections.GermanyMinden }"
                class="cursor-pointer" cy="157.8" r="2.5" />
            <circle class="st0" cx="439.5" cy="164.6" r="1.9" />
            <circle class="st0" cx="439.5" cy="171.3" r="1.9" />
            <circle class="st0" cx="439.5" cy="178.1" r="1.9" />
            <circle class="st0" cx="439.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="439.5" cy="218.8" r="1.9" />
            <circle class="st0" cx="439.5" cy="225.6" r="1.9" />
            <circle class="st0" cx="439.5" cy="232.4" r="1.9" />
            <circle class="st0" cx="439.5" cy="239.2" r="1.9" />
            <circle class="st0" cx="439.5" cy="246" r="1.9" />
            <circle class="st0" cx="439.5" cy="252.7" r="1.9" />
            <circle class="st0" cx="439.5" cy="259.5" r="1.9" />
            <circle class="st0" cx="439.5" cy="266.3" r="1.9" />
            <circle class="st0" cx="439.5" cy="273.1" r="1.9" />
            <circle class="st0" cx="439.5" cy="279.9" r="1.9" />
            <circle class="st0" cx="439.5" cy="286.6" r="1.9" />
            <circle class="st0" cx="439.5" cy="293.4" r="1.9" />
            <circle class="st0" cx="439.5" cy="300.2" r="1.9" />
            <circle class="st0" cx="439.5" cy="307" r="1.9" />
            <circle class="st0" cx="439.5" cy="313.8" r="1.9" />
            <circle class="st0" cx="439.5" cy="320.6" r="1.9" />
            <circle class="st0" cx="439.5" cy="327.3" r="1.9" />
            <circle class="st0" cx="439.5" cy="334.1" r="1.9" />
            <circle class="st0" cx="439.5" cy="340.9" r="1.9" />
            <circle class="st0" cx="439.5" cy="347.7" r="1.9" />
            <circle class="st0" cx="439.5" cy="354.5" r="1.9" />
            <circle class="st0" cx="439.5" cy="361.3" r="1.9" />
            <circle class="st0" cx="439.5" cy="368" r="1.9" />
            <circle class="st0" cx="432.8" cy="56" r="1.9" />
            <circle class="st0" cx="432.8" cy="62.8" r="1.9" />
            <circle class="st0" cx="432.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="432.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="432.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="432.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="432.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="432.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="432.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="432.8" cy="151" r="1.9" />
            <circle class="st0" cx="432.8" cy="157.8" r="1.9" />
            <circle @mouseenter="toggleReviewSection('GermanyHaltern')"
                :class="{ 'fill-[#FD833F40]': reviewSections.GermanyHaltern, 'fill-[#cbd1d926]': !reviewSections.GermanyHaltern }"
                cx="432.8" class="cursor-pointer" cy="164.6" r="8.9" />
            <circle @mouseenter="toggleReviewSection('GermanyHaltern')" cx="432.8"
                :class="{ 'fill-mainColor': reviewSections.GermanyHaltern, 'fill-[#5F6177]': !reviewSections.GermanyHaltern }"
                class="cursor-pointer" cy="164.6" r="2.5" />
            <circle class="st0" cx="432.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="432.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="432.8" cy="191.7" r="1.9" />
            <circle class="st0" cx="432.8" cy="198.5" r="1.9" />
            <circle class="st0" cx="432.8" cy="218.8" r="1.9" />
            <circle class="st0" cx="432.8" cy="225.6" r="1.9" />
            <circle class="st0" cx="432.8" cy="232.4" r="1.9" />
            <circle class="st0" cx="432.8" cy="239.2" r="1.9" />
            <circle class="st0" cx="432.8" cy="246" r="1.9" />
            <circle class="st0" cx="432.8" cy="252.7" r="1.9" />
            <circle class="st0" cx="432.8" cy="259.5" r="1.9" />
            <circle class="st0" cx="432.8" cy="266.3" r="1.9" />
            <circle class="st0" cx="432.8" cy="273.1" r="1.9" />
            <circle class="st0" cx="432.8" cy="279.9" r="1.9" />
            <circle class="st0" cx="432.8" cy="286.6" r="1.9" />
            <circle class="st0" cx="432.8" cy="293.4" r="1.9" />
            <circle class="st0" cx="432.8" cy="300.2" r="1.9" />
            <circle class="st0" cx="432.8" cy="307" r="1.9" />
            <circle class="st0" cx="432.8" cy="313.8" r="1.9" />
            <circle class="st0" cx="432.8" cy="320.6" r="1.9" />
            <circle class="st0" cx="432.8" cy="327.3" r="1.9" />
            <circle class="st0" cx="432.8" cy="334.1" r="1.9" />
            <circle class="st0" cx="432.8" cy="340.9" r="1.9" />
            <circle class="st0" cx="432.8" cy="347.7" r="1.9" />
            <circle class="st0" cx="426" cy="56" r="1.9" />
            <circle class="st0" cx="426" cy="110.3" r="1.9" />
            <circle class="st0" cx="426" cy="117.1" r="1.9" />
            <circle class="st0" cx="426" cy="123.9" r="1.9" />
            <circle class="st0" cx="426" cy="130.7" r="1.9" />
            <circle class="st0" cx="426" cy="137.4" r="1.9" />
            <circle class="st0" cx="426" cy="151" r="1.9" />
            <circle class="st0" cx="426" cy="157.8" r="1.9" />
            <circle class="st0" cx="426" cy="164.6" r="1.9" />
            <circle class="st0" cx="426" cy="171.3" r="1.9" />
            <circle class="st0" cx="426" cy="178.1" r="1.9" />
            <circle class="st0" cx="426" cy="184.9" r="1.9" />
            <circle class="st0" cx="426" cy="198.5" r="1.9" />
            <circle class="st0" cx="426" cy="212" r="1.9" />
            <circle class="st0" cx="426" cy="218.8" r="1.9" />
            <circle class="st0" cx="426" cy="225.6" r="1.9" />
            <circle class="st0" cx="426" cy="232.4" r="1.9" />
            <circle class="st0" cx="426" cy="239.2" r="1.9" />
            <circle class="st0" cx="426" cy="246" r="1.9" />
            <circle class="st0" cx="426" cy="252.7" r="1.9" />
            <circle class="st0" cx="426" cy="259.5" r="1.9" />
            <circle class="st0" cx="426" cy="266.3" r="1.9" />
            <circle class="st0" cx="426" cy="273.1" r="1.9" />
            <circle class="st0" cx="426" cy="279.9" r="1.9" />
            <circle class="st0" cx="426" cy="286.6" r="1.9" />
            <circle class="st0" cx="426" cy="293.4" r="1.9" />
            <circle class="st0" cx="426" cy="300.2" r="1.9" />
            <circle class="st0" cx="426" cy="320.6" r="1.9" />
            <circle class="st0" cx="426" cy="327.3" r="1.9" />
            <circle class="st0" cx="419.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="419.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="419.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="419.2" cy="137.4" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Denmark')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Denmark, 'fill-[#cbd1d926]': !reviewSections.Denmark }"
                cx="419.2" class="cursor-pointer" cy="144.2" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Denmark')" cx="419.2"
                :class="{ 'fill-mainColor': reviewSections.Denmark, 'fill-[#5F6177]': !reviewSections.Denmark }"
                class="cursor-pointer" cy="144.2" r="2.5" />
            <circle class="st0" cx="419.2" cy="151" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Netherlands')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Netherlands, 'fill-[#cbd1d926]': !reviewSections.Netherlands }"
                cx="419.2" class="cursor-pointer" cy="157.8" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Netherlands')" cx="419.2"
                :class="{ 'fill-mainColor': reviewSections.Netherlands, 'fill-[#5F6177]': !reviewSections.Netherlands }"
                class="cursor-pointer" cy="157.8" r="2.5" />
            <circle class="st0" cx="419.2" cy="164.6" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Germany')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Germany, 'fill-[#cbd1d926]': !reviewSections.Germany }"
                cx="419.2" class="cursor-pointer" cy="171.3" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Germany')" cx="419.2"
                :class="{ 'fill-mainColor': reviewSections.Germany, 'fill-[#5F6177]': !reviewSections.Germany }"
                class="cursor-pointer" cy="171.3" r="2.5" />
            <circle class="st0" cx="419.2" cy="178.1" r="1.9" />
            <circle class="st0" cx="419.2" cy="184.9" r="1.9" />
            <circle class="st0" cx="419.2" cy="191.7" r="1.9" />
            <circle class="st0" cx="419.2" cy="205.3" r="1.9" />
            <circle class="st0" cx="419.2" cy="212" r="1.9" />
            <circle class="st0" cx="419.2" cy="218.8" r="1.9" />
            <circle class="st0" cx="419.2" cy="225.6" r="1.9" />
            <circle class="st0" cx="419.2" cy="232.4" r="1.9" />
            <circle class="st0" cx="419.2" cy="239.2" r="1.9" />
            <circle class="st0" cx="419.2" cy="246" r="1.9" />
            <circle class="st0" cx="419.2" cy="252.7" r="1.9" />
            <circle class="st0" cx="419.2" cy="259.5" r="1.9" />
            <circle class="st0" cx="419.2" cy="266.3" r="1.9" />
            <circle class="st0" cx="419.2" cy="273.1" r="1.9" />
            <circle class="st0" cx="419.2" cy="279.9" r="1.9" />
            <circle class="st0" cx="419.2" cy="286.6" r="1.9" />
            <circle class="st0" cx="419.2" cy="293.4" r="1.9" />
            <circle class="st0" cx="412.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="412.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="412.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="412.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="412.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="412.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="412.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="412.4" cy="184.9" r="1.9" />
            <circle class="st0" cx="412.4" cy="205.3" r="1.9" />
            <circle class="st0" cx="412.4" cy="212" r="1.9" />
            <circle class="st0" cx="412.4" cy="218.8" r="1.9" />
            <circle class="st0" cx="412.4" cy="225.6" r="1.9" />
            <circle class="st0" cx="412.4" cy="232.4" r="1.9" />
            <circle class="st0" cx="412.4" cy="239.2" r="1.9" />
            <circle class="st0" cx="412.4" cy="246" r="1.9" />
            <circle class="st0" cx="412.4" cy="252.7" r="1.9" />
            <circle class="st0" cx="412.4" cy="259.5" r="1.9" />
            <circle class="st0" cx="412.4" cy="266.3" r="1.9" />
            <circle class="st0" cx="412.4" cy="273.1" r="1.9" />
            <circle class="st0" cx="405.6" cy="164.6" r="1.9" />
            <circle class="st0" cx="405.6" cy="171.3" r="1.9" />
            <circle class="st0" cx="405.6" cy="178.1" r="1.9" />
            <circle class="st0" cx="405.6" cy="184.9" r="1.9" />
            <circle class="st0" cx="405.6" cy="205.3" r="1.9" />
            <circle class="st0" cx="405.6" cy="212" r="1.9" />
            <circle class="st0" cx="405.6" cy="218.8" r="1.9" />
            <circle class="st0" cx="405.6" cy="225.6" r="1.9" />
            <circle class="st0" cx="405.6" cy="232.4" r="1.9" />
            <circle class="st0" cx="405.6" cy="239.2" r="1.9" />
            <circle class="st0" cx="405.6" cy="246" r="1.9" />
            <circle class="st0" cx="405.6" cy="252.7" r="1.9" />
            <circle class="st0" cx="405.6" cy="259.5" r="1.9" />
            <circle class="st0" cx="405.6" cy="266.3" r="1.9" />
            <circle class="st0" cx="405.6" cy="273.1" r="1.9" />
            <circle class="st0" cx="398.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="398.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="392.1" cy="171.3" r="1.9" />
            <circle class="st0" cx="385.3" cy="171.3" r="1.9" />
            <circle class="st0" cx="398.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="398.8" cy="184.9" r="1.9" />
            <circle class="st1" cx="398.8" cy="191.7" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Spain')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Spain, 'fill-[#cbd1d926]': !reviewSections.Spain }" cx="398.8"
                class="cursor-pointer" cy="191.7" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Spain')" cx="398.8"
                :class="{ 'fill-mainColor': reviewSections.Spain, 'fill-[#5F6177]': !reviewSections.Spain }"
                class="cursor-pointer" cy="191.7" r="2.5" />
            <circle class="st0" cx="398.8" cy="205.3" r="1.9" />
            <circle class="st0" cx="398.8" cy="212" r="1.9" />
            <circle class="st0" cx="398.8" cy="218.8" r="1.9" />
            <circle class="st0" cx="398.8" cy="225.6" r="1.9" />
            <circle class="st0" cx="398.8" cy="232.4" r="1.9" />
            <circle class="st0" cx="398.8" cy="239.2" r="1.9" />
            <circle class="st0" cx="398.8" cy="246" r="1.9" />
            <circle class="st0" cx="398.8" cy="252.7" r="1.9" />
            <circle class="st0" cx="398.8" cy="259.5" r="1.9" />
            <circle class="st0" cx="398.8" cy="266.3" r="1.9" />
            <circle class="st0" cx="398.8" cy="273.1" r="1.9" />
            <circle class="st0" cx="392.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="392.1" cy="191.7" r="1.9" />
            <circle class="st0" cx="392.1" cy="198.5" r="1.9" />
            <circle class="st0" cx="392.1" cy="205.3" r="1.9" />
            <circle class="st0" cx="392.1" cy="212" r="1.9" />
            <circle class="st0" cx="392.1" cy="218.8" r="1.9" />
            <circle class="st0" cx="392.1" cy="225.6" r="1.9" />
            <circle class="st0" cx="392.1" cy="232.4" r="1.9" />
            <circle class="st0" cx="392.1" cy="239.2" r="1.9" />
            <circle class="st0" cx="392.1" cy="246" r="1.9" />
            <circle class="st0" cx="392.1" cy="252.7" r="1.9" />
            <circle class="st0" cx="392.1" cy="259.5" r="1.9" />
            <circle class="st0" cx="392.1" cy="266.3" r="1.9" />
            <circle class="st0" cx="392.1" cy="273.1" r="1.9" />
            <circle class="st0" cx="385.3" cy="184.9" r="1.9" />
            <circle class="st0" cx="385.3" cy="191.7" r="1.9" />
            <circle class="st0" cx="385.3" cy="198.5" r="1.9" />
            <circle class="st0" cx="385.3" cy="205.3" r="1.9" />
            <circle class="st0" cx="385.3" cy="212" r="1.9" />
            <circle class="st0" cx="385.3" cy="218.8" r="1.9" />
            <circle class="st0" cx="385.3" cy="225.6" r="1.9" />
            <circle class="st0" cx="385.3" cy="232.4" r="1.9" />
            <circle class="st0" cx="385.3" cy="239.2" r="1.9" />
            <circle class="st0" cx="385.3" cy="246" r="1.9" />
            <circle class="st0" cx="385.3" cy="252.7" r="1.9" />
            <circle class="st0" cx="385.3" cy="259.5" r="1.9" />
            <circle class="st0" cx="385.3" cy="266.3" r="1.9" />
            <circle class="st0" cx="385.3" cy="273.1" r="1.9" />
            <circle class="st0" cx="385.3" cy="279.9" r="1.9" />
            <circle class="st0" cx="378.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="378.5" cy="191.7" r="1.9" />
            <circle class="st0" cx="378.5" cy="198.5" r="1.9" />
            <circle class="st0" cx="378.5" cy="212" r="1.9" />
            <circle class="st0" cx="378.5" cy="218.8" r="1.9" />
            <circle class="st0" cx="378.5" cy="225.6" r="1.9" />
            <circle class="st0" cx="378.5" cy="232.4" r="1.9" />
            <circle class="st0" cx="378.5" cy="239.2" r="1.9" />
            <circle class="st0" cx="378.5" cy="246" r="1.9" />
            <circle class="st0" cx="378.5" cy="252.7" r="1.9" />
            <circle class="st0" cx="378.5" cy="259.5" r="1.9" />
            <circle class="st0" cx="378.5" cy="266.3" r="1.9" />
            <circle class="st0" cx="378.5" cy="273.1" r="1.9" />
            <circle class="st0" cx="378.5" cy="279.9" r="1.9" />
            <circle class="st0" cx="371.7" cy="42.5" r="1.9" />
            <circle class="st0" cx="371.7" cy="225.6" r="1.9" />
            <circle class="st0" cx="371.7" cy="232.4" r="1.9" />
            <circle class="st0" cx="371.7" cy="239.2" r="1.9" />
            <circle class="st0" cx="371.7" cy="246" r="1.9" />
            <circle class="st0" cx="371.7" cy="252.7" r="1.9" />
            <circle class="st0" cx="371.7" cy="259.5" r="1.9" />
            <circle class="st0" cx="371.7" cy="266.3" r="1.9" />
            <circle class="st0" cx="371.7" cy="273.1" r="1.9" />
            <circle class="st0" cx="364.9" cy="42.5" r="1.9" />
            <circle class="st0" cx="364.9" cy="232.4" r="1.9" />
            <circle class="st0" cx="364.9" cy="239.2" r="1.9" />
            <circle class="st0" cx="364.9" cy="246" r="1.9" />
            <circle class="st0" cx="364.9" cy="252.7" r="1.9" />
            <circle class="st0" cx="364.9" cy="259.5" r="1.9" />
            <circle class="st0" cx="358.1" cy="42.5" r="1.9" />
            <circle class="st0" cx="358.1" cy="49.3" r="1.9" />
            <circle class="st0" cx="358.1" cy="239.2" r="1.9" />
            <circle class="st0" cx="351.4" cy="35.7" r="1.9" />
            <circle class="st0" cx="351.4" cy="42.5" r="1.9" />
            <circle class="st0" cx="351.4" cy="49.3" r="1.9" />
            <circle class="st0" cx="351.4" cy="56" r="1.9" />
            <circle class="st0" cx="351.4" cy="62.8" r="1.9" />
            <circle class="st0" cx="351.4" cy="69.6" r="1.9" />
            <circle class="st0" cx="351.4" cy="76.4" r="1.9" />
            <circle class="st0" cx="344.6" cy="35.7" r="1.9" />
            <circle class="st0" cx="344.6" cy="42.5" r="1.9" />
            <circle class="st0" cx="344.6" cy="49.3" r="1.9" />
            <circle class="st0" cx="344.6" cy="56" r="1.9" />
            <circle class="st0" cx="344.6" cy="62.8" r="1.9" />
            <circle class="st0" cx="344.6" cy="69.6" r="1.9" />
            <circle class="st0" cx="344.6" cy="76.4" r="1.9" />
            <circle class="st0" cx="344.6" cy="83.2" r="1.9" />
            <circle class="st0" cx="344.6" cy="90" r="1.9" />
            <circle class="st0" cx="344.6" cy="96.7" r="1.9" />
            <circle class="st0" cx="337.8" cy="28.9" r="1.9" />
            <circle class="st0" cx="337.8" cy="35.7" r="1.9" />
            <circle class="st0" cx="337.8" cy="42.5" r="1.9" />
            <circle class="st0" cx="337.8" cy="49.3" r="1.9" />
            <circle class="st0" cx="337.8" cy="56" r="1.9" />
            <circle class="st0" cx="337.8" cy="62.8" r="1.9" />
            <circle class="st0" cx="337.8" cy="69.6" r="1.9" />
            <circle class="st0" cx="337.8" cy="76.4" r="1.9" />
            <circle class="st0" cx="337.8" cy="83.2" r="1.9" />
            <circle class="st0" cx="337.8" cy="90" r="1.9" />
            <circle class="st0" cx="337.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="331" cy="28.9" r="1.9" />
            <circle class="st0" cx="331" cy="35.7" r="1.9" />
            <circle class="st0" cx="331" cy="42.5" r="1.9" />
            <circle class="st0" cx="331" cy="49.3" r="1.9" />
            <circle class="st0" cx="331" cy="56" r="1.9" />
            <circle class="st0" cx="331" cy="62.8" r="1.9" />
            <circle class="st0" cx="331" cy="69.6" r="1.9" />
            <circle class="st0" cx="331" cy="76.4" r="1.9" />
            <circle class="st0" cx="331" cy="83.2" r="1.9" />
            <circle class="st0" cx="331" cy="90" r="1.9" />
            <circle class="st0" cx="331" cy="96.7" r="1.9" />
            <circle class="st0" cx="331" cy="103.5" r="1.9" />
            <circle class="st0" cx="324.2" cy="28.9" r="1.9" />
            <circle class="st0" cx="324.2" cy="35.7" r="1.9" />
            <circle class="st0" cx="324.2" cy="42.5" r="1.9" />
            <circle class="st0" cx="324.2" cy="49.3" r="1.9" />
            <circle class="st0" cx="324.2" cy="56" r="1.9" />
            <circle class="st0" cx="324.2" cy="62.8" r="1.9" />
            <circle class="st0" cx="324.2" cy="69.6" r="1.9" />
            <circle class="st0" cx="324.2" cy="76.4" r="1.9" />
            <circle class="st0" cx="324.2" cy="83.2" r="1.9" />
            <circle class="st0" cx="324.2" cy="90" r="1.9" />
            <circle class="st0" cx="324.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="324.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="317.5" cy="28.9" r="1.9" />
            <circle class="st0" cx="317.5" cy="35.7" r="1.9" />
            <circle class="st0" cx="317.5" cy="42.5" r="1.9" />
            <circle class="st0" cx="317.5" cy="49.3" r="1.9" />
            <circle class="st0" cx="317.5" cy="56" r="1.9" />
            <circle class="st0" cx="317.5" cy="62.8" r="1.9" />
            <circle class="st0" cx="317.5" cy="69.6" r="1.9" />
            <circle class="st0" cx="317.5" cy="76.4" r="1.9" />
            <circle class="st0" cx="317.5" cy="83.2" r="1.9" />
            <circle class="st0" cx="317.5" cy="90" r="1.9" />
            <circle class="st0" cx="317.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="317.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="317.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="317.5" cy="300.2" r="1.9" />
            <circle class="st0" cx="317.5" cy="307" r="1.9" />
            <circle class="st0" cx="310.7" cy="28.9" r="1.9" />
            <circle class="st0" cx="310.7" cy="35.7" r="1.9" />
            <circle class="st0" cx="310.7" cy="42.5" r="1.9" />
            <circle class="st0" cx="310.7" cy="49.3" r="1.9" />
            <circle class="st0" cx="310.7" cy="56" r="1.9" />
            <circle class="st0" cx="310.7" cy="62.8" r="1.9" />
            <circle class="st0" cx="310.7" cy="69.6" r="1.9" />
            <circle class="st0" cx="310.7" cy="76.4" r="1.9" />
            <circle class="st0" cx="310.7" cy="83.2" r="1.9" />
            <circle class="st0" cx="310.7" cy="90" r="1.9" />
            <circle class="st0" cx="310.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="310.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="310.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="310.7" cy="300.2" r="1.9" />
            <circle class="st0" cx="310.7" cy="307" r="1.9" />
            <circle class="st0" cx="310.7" cy="313.8" r="1.9" />
            <circle class="st0" cx="310.7" cy="320.6" r="1.9" />
            <circle class="st0" cx="310.7" cy="327.3" r="1.9" />
            <circle class="st0" cx="303.9" cy="35.7" r="1.9" />
            <circle class="st0" cx="303.9" cy="42.5" r="1.9" />
            <circle class="st0" cx="303.9" cy="49.3" r="1.9" />
            <circle class="st0" cx="303.9" cy="56" r="1.9" />
            <circle class="st0" cx="303.9" cy="62.8" r="1.9" />
            <circle class="st0" cx="303.9" cy="69.6" r="1.9" />
            <circle class="st0" cx="303.9" cy="76.4" r="1.9" />
            <circle class="st0" cx="303.9" cy="83.2" r="1.9" />
            <circle class="st0" cx="303.9" cy="90" r="1.9" />
            <circle class="st0" cx="303.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="303.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="303.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="303.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="303.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="303.9" cy="300.2" r="1.9" />
            <circle class="st0" cx="303.9" cy="307" r="1.9" />
            <circle class="st0" cx="303.9" cy="313.8" r="1.9" />
            <circle class="st0" cx="303.9" cy="320.6" r="1.9" />
            <circle class="st0" cx="303.9" cy="327.3" r="1.9" />
            <circle class="st0" cx="303.9" cy="334.1" r="1.9" />
            <circle class="st0" cx="303.9" cy="340.9" r="1.9" />
            <circle class="st0" cx="297.1" cy="35.7" r="1.9" />
            <circle class="st0" cx="297.1" cy="42.5" r="1.9" />
            <circle class="st0" cx="297.1" cy="49.3" r="1.9" />
            <circle class="st0" cx="297.1" cy="56" r="1.9" />
            <circle class="st0" cx="297.1" cy="62.8" r="1.9" />
            <circle class="st0" cx="297.1" cy="69.6" r="1.9" />
            <circle class="st0" cx="297.1" cy="76.4" r="1.9" />
            <circle class="st0" cx="297.1" cy="83.2" r="1.9" />
            <circle class="st0" cx="297.1" cy="90" r="1.9" />
            <circle class="st0" cx="297.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="297.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="297.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="297.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="297.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="297.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="297.1" cy="293.4" r="1.9" />
            <circle class="st0" cx="297.1" cy="300.2" r="1.9" />
            <circle class="st0" cx="297.1" cy="307" r="1.9" />
            <circle class="st0" cx="297.1" cy="313.8" r="1.9" />
            <circle class="st0" cx="297.1" cy="320.6" r="1.9" />
            <circle class="st0" cx="297.1" cy="327.3" r="1.9" />
            <circle class="st0" cx="297.1" cy="334.1" r="1.9" />
            <circle class="st0" cx="297.1" cy="340.9" r="1.9" />
            <circle class="st0" cx="290.3" cy="35.7" r="1.9" />
            <circle class="st0" cx="290.3" cy="42.5" r="1.9" />
            <circle class="st0" cx="290.3" cy="49.3" r="1.9" />
            <circle class="st0" cx="290.3" cy="56" r="1.9" />
            <circle class="st0" cx="290.3" cy="62.8" r="1.9" />
            <circle class="st0" cx="290.3" cy="69.6" r="1.9" />
            <circle class="st0" cx="290.3" cy="76.4" r="1.9" />
            <circle class="st0" cx="290.3" cy="83.2" r="1.9" />
            <circle class="st0" cx="290.3" cy="90" r="1.9" />
            <circle class="st0" cx="290.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="290.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="290.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="290.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="290.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="290.3" cy="130.7" r="1.9" />
            <circle class="st0" cx="290.3" cy="293.4" r="1.9" />
            <circle class="st0" cx="290.3" cy="300.2" r="1.9" />
            <circle class="st0" cx="290.3" cy="307" r="1.9" />
            <circle class="st0" cx="290.3" cy="313.8" r="1.9" />
            <circle class="st0" cx="290.3" cy="320.6" r="1.9" />
            <circle class="st0" cx="290.3" cy="327.3" r="1.9" />
            <circle class="st0" cx="290.3" cy="334.1" r="1.9" />
            <circle class="st0" cx="290.3" cy="340.9" r="1.9" />
            <circle class="st0" cx="290.3" cy="347.7" r="1.9" />
            <circle class="st0" cx="283.5" cy="35.7" r="1.9" />
            <circle class="st0" cx="283.5" cy="42.5" r="1.9" />
            <circle class="st0" cx="283.5" cy="49.3" r="1.9" />
            <circle class="st0" cx="283.5" cy="56" r="1.9" />
            <circle class="st0" cx="283.5" cy="62.8" r="1.9" />
            <circle class="st0" cx="283.5" cy="69.6" r="1.9" />
            <circle class="st0" cx="283.5" cy="76.4" r="1.9" />
            <circle class="st0" cx="283.5" cy="83.2" r="1.9" />
            <circle class="st0" cx="283.5" cy="90" r="1.9" />
            <circle class="st0" cx="283.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="283.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="283.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="283.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="283.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="283.5" cy="279.9" r="1.9" />
            <circle class="st0" cx="283.5" cy="286.6" r="1.9" />
            <circle class="st0" cx="283.5" cy="293.4" r="1.9" />
            <circle class="st0" cx="283.5" cy="300.2" r="1.9" />
            <circle class="st0" cx="283.5" cy="307" r="1.9" />
            <circle class="st0" cx="283.5" cy="313.8" r="1.9" />
            <circle class="st0" cx="283.5" cy="320.6" r="1.9" />
            <circle class="st0" cx="283.5" cy="327.3" r="1.9" />
            <circle class="st0" cx="283.5" cy="334.1" r="1.9" />
            <circle class="st0" cx="283.5" cy="340.9" r="1.9" />
            <circle class="st0" cx="283.5" cy="347.7" r="1.9" />
            <circle class="st0" cx="283.5" cy="354.5" r="1.9" />
            <circle class="st0" cx="283.5" cy="361.3" r="1.9" />
            <circle class="st0" cx="276.8" cy="42.5" r="1.9" />
            <circle class="st0" cx="276.8" cy="49.3" r="1.9" />
            <circle class="st0" cx="276.8" cy="56" r="1.9" />
            <circle class="st0" cx="276.8" cy="62.8" r="1.9" />
            <circle class="st0" cx="276.8" cy="69.6" r="1.9" />
            <circle class="st0" cx="276.8" cy="76.4" r="1.9" />
            <circle class="st0" cx="276.8" cy="83.2" r="1.9" />
            <circle class="st0" cx="276.8" cy="90" r="1.9" />
            <circle class="st0" cx="276.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="276.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="276.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="276.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="276.8" cy="279.9" r="1.9" />
            <circle class="st0" cx="276.8" cy="286.6" r="1.9" />
            <circle class="st0" cx="276.8" cy="293.4" r="1.9" />
            <circle class="st0" cx="276.8" cy="300.2" r="1.9" />
            <circle class="st0" cx="276.8" cy="307" r="1.9" />
            <circle class="st0" cx="276.8" cy="313.8" r="1.9" />
            <circle class="st0" cx="276.8" cy="320.6" r="1.9" />
            <circle class="st0" cx="276.8" cy="327.3" r="1.9" />
            <circle class="st0" cx="276.8" cy="334.1" r="1.9" />
            <circle class="st0" cx="276.8" cy="340.9" r="1.9" />
            <circle class="st0" cx="276.8" cy="347.7" r="1.9" />
            <circle class="st0" cx="276.8" cy="354.5" r="1.9" />
            <circle class="st0" cx="276.8" cy="361.3" r="1.9" />
            <circle class="st0" cx="276.8" cy="368" r="1.9" />
            <circle class="st0" cx="270" cy="42.5" r="1.9" />
            <circle class="st0" cx="270" cy="49.3" r="1.9" />
            <circle class="st0" cx="270" cy="56" r="1.9" />
            <circle class="st0" cx="270" cy="62.8" r="1.9" />
            <circle class="st0" cx="270" cy="69.6" r="1.9" />
            <circle class="st0" cx="270" cy="76.4" r="1.9" />
            <circle class="st0" cx="270" cy="157.8" r="1.9" />
            <circle class="st0" cx="270" cy="164.6" r="1.9" />
            <circle class="st0" cx="270" cy="171.3" r="1.9" />
            <circle class="st0" cx="270" cy="279.9" r="1.9" />
            <circle class="st0" cx="270" cy="286.6" r="1.9" />
            <circle class="st0" cx="270" cy="293.4" r="1.9" />
            <circle class="st0" cx="270" cy="300.2" r="1.9" />
            <circle class="st0" cx="270" cy="307" r="1.9" />
            <circle class="st0" cx="270" cy="313.8" r="1.9" />
            <circle class="st0" cx="270" cy="320.6" r="1.9" />
            <circle class="st0" cx="270" cy="327.3" r="1.9" />
            <circle class="st0" cx="270" cy="334.1" r="1.9" />
            <circle class="st0" cx="270" cy="340.9" r="1.9" />
            <circle class="st0" cx="270" cy="347.7" r="1.9" />
            <circle class="st0" cx="270" cy="354.5" r="1.9" />
            <circle class="st0" cx="270" cy="361.3" r="1.9" />
            <circle class="st0" cx="270" cy="368" r="1.9" />
            <circle class="st0" cx="270" cy="374.8" r="1.9" />
            <circle class="st0" cx="263.2" cy="42.5" r="1.9" />
            <circle class="st0" cx="263.2" cy="49.3" r="1.9" />
            <circle class="st0" cx="263.2" cy="56" r="1.9" />
            <circle class="st0" cx="263.2" cy="62.8" r="1.9" />
            <circle class="st0" cx="263.2" cy="69.6" r="1.9" />
            <circle class="st0" cx="263.2" cy="151" r="1.9" />
            <circle class="st0" cx="263.2" cy="157.8" r="1.9" />
            <circle class="st0" cx="263.2" cy="171.3" r="1.9" />
            <circle class="st0" cx="263.2" cy="273.1" r="1.9" />
            <circle class="st0" cx="263.2" cy="279.9" r="1.9" />
            <circle class="st0" cx="263.2" cy="286.6" r="1.9" />
            <circle class="st0" cx="263.2" cy="293.4" r="1.9" />
            <circle class="st0" cx="263.2" cy="300.2" r="1.9" />
            <circle class="st0" cx="263.2" cy="307" r="1.9" />
            <circle class="st0" cx="263.2" cy="313.8" r="1.9" />
            <circle class="st0" cx="263.2" cy="320.6" r="1.9" />
            <circle class="st0" cx="263.2" cy="327.3" r="1.9" />
            <circle class="st0" cx="263.2" cy="334.1" r="1.9" />
            <circle class="st0" cx="263.2" cy="340.9" r="1.9" />
            <circle class="st0" cx="263.2" cy="347.7" r="1.9" />
            <circle class="st0" cx="263.2" cy="354.5" r="1.9" />
            <circle class="st0" cx="263.2" cy="361.3" r="1.9" />
            <circle class="st0" cx="263.2" cy="368" r="1.9" />
            <circle class="st0" cx="263.2" cy="374.8" r="1.9" />
            <circle class="st0" cx="263.2" cy="381.6" r="1.9" />
            <circle class="st0" cx="256.4" cy="35.7" r="1.9" />
            <circle class="st0" cx="256.4" cy="42.5" r="1.9" />
            <circle class="st0" cx="256.4" cy="49.3" r="1.9" />
            <circle class="st0" cx="256.4" cy="56" r="1.9" />
            <circle class="st0" cx="256.4" cy="62.8" r="1.9" />
            <circle class="st0" cx="256.4" cy="69.6" r="1.9" />
            <circle class="st0" cx="256.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="256.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="256.4" cy="151" r="1.9" />
            <circle class="st0" cx="256.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="256.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="256.4" cy="266.3" r="1.9" />
            <circle class="st0" cx="256.4" cy="273.1" r="1.9" />
            <circle class="st0" cx="256.4" cy="279.9" r="1.9" />
            <circle class="st0" cx="256.4" cy="286.6" r="1.9" />
            <circle class="st0" cx="256.4" cy="293.4" r="1.9" />
            <circle class="st0" cx="256.4" cy="300.2" r="1.9" />
            <circle class="st0" cx="256.4" cy="307" r="1.9" />
            <circle class="st0" cx="256.4" cy="313.8" r="1.9" />
            <circle class="st0" cx="256.4" cy="320.6" r="1.9" />
            <circle class="st0" cx="256.4" cy="327.3" r="1.9" />
            <circle class="st0" cx="256.4" cy="334.1" r="1.9" />
            <circle class="st0" cx="256.4" cy="340.9" r="1.9" />
            <circle class="st0" cx="256.4" cy="347.7" r="1.9" />
            <circle class="st0" cx="256.4" cy="354.5" r="1.9" />
            <circle class="st0" cx="256.4" cy="361.3" r="1.9" />
            <circle class="st0" cx="256.4" cy="368" r="1.9" />
            <circle class="st0" cx="256.4" cy="374.8" r="1.9" />
            <circle class="st0" cx="256.4" cy="381.6" r="1.9" />
            <circle class="st0" cx="256.4" cy="388.4" r="1.9" />
            <circle class="st0" cx="249.6" cy="35.7" r="1.9" />
            <circle class="st0" cx="249.6" cy="42.5" r="1.9" />
            <circle class="st0" cx="249.6" cy="49.3" r="1.9" />
            <circle class="st0" cx="249.6" cy="56" r="1.9" />
            <circle class="st0" cx="249.6" cy="62.8" r="1.9" />
            <circle class="st0" cx="249.6" cy="69.6" r="1.9" />
            <circle class="st0" cx="249.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="249.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="249.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="249.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="249.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="249.6" cy="144.2" r="1.9" />
            <circle class="st0" cx="249.6" cy="151" r="1.9" />
            <circle class="st0" cx="249.6" cy="157.8" r="1.9" />
            <circle class="st0" cx="249.6" cy="171.3" r="1.9" />
            <circle class="st0" cx="249.6" cy="178.1" r="1.9" />
            <circle class="st0" cx="249.6" cy="246" r="1.9" />
            <circle class="st0" cx="249.6" cy="266.3" r="1.9" />
            <circle class="st0" cx="249.6" cy="273.1" r="1.9" />
            <circle class="st0" cx="249.6" cy="279.9" r="1.9" />
            <circle class="st0" cx="249.6" cy="286.6" r="1.9" />
            <circle class="st0" cx="249.6" cy="293.4" r="1.9" />
            <circle class="st0" cx="249.6" cy="300.2" r="1.9" />
            <circle class="st0" cx="249.6" cy="307" r="1.9" />
            <circle class="st0" cx="249.6" cy="313.8" r="1.9" />
            <circle class="st0" cx="249.6" cy="320.6" r="1.9" />
            <circle class="st0" cx="249.6" cy="327.3" r="1.9" />
            <circle class="st0" cx="249.6" cy="334.1" r="1.9" />
            <circle class="st0" cx="249.6" cy="340.9" r="1.9" />
            <circle class="st0" cx="249.6" cy="347.7" r="1.9" />
            <circle class="st0" cx="249.6" cy="354.5" r="1.9" />
            <circle class="st0" cx="249.6" cy="361.3" r="1.9" />
            <circle class="st0" cx="249.6" cy="368" r="1.9" />
            <circle class="st0" cx="249.6" cy="374.8" r="1.9" />
            <circle class="st0" cx="249.6" cy="381.6" r="1.9" />
            <circle class="st0" cx="249.6" cy="388.4" r="1.9" />
            <circle class="st0" cx="249.6" cy="395.2" r="1.9" />
            <circle class="st0" cx="249.6" cy="429.1" r="1.9" />
            <circle class="st0" cx="242.8" cy="35.7" r="1.9" />
            <circle class="st0" cx="242.8" cy="42.5" r="1.9" />
            <circle class="st0" cx="242.8" cy="56" r="1.9" />
            <circle class="st0" cx="242.8" cy="62.8" r="1.9" />
            <circle class="st0" cx="242.8" cy="69.6" r="1.9" />
            <circle class="st0" cx="242.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="242.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="242.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="242.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="242.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="242.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="242.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="242.8" cy="151" r="1.9" />
            <circle class="st0" cx="242.8" cy="157.8" r="1.9" />
            <circle class="st0" cx="242.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="242.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="242.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="242.8" cy="246" r="1.9" />
            <circle class="st0" cx="242.8" cy="266.3" r="1.9" />
            <circle class="st0" cx="242.8" cy="273.1" r="1.9" />
            <circle class="st0" cx="242.8" cy="279.9" r="1.9" />
            <circle class="st0" cx="242.8" cy="286.6" r="1.9" />
            <circle class="st0" cx="242.8" cy="293.4" r="1.9" />
            <circle class="st0" cx="242.8" cy="300.2" r="1.9" />
            <circle class="st0" cx="242.8" cy="307" r="1.9" />
            <circle class="st0" cx="242.8" cy="313.8" r="1.9" />
            <circle class="st0" cx="242.8" cy="320.6" r="1.9" />
            <circle class="st0" cx="242.8" cy="327.3" r="1.9" />
            <circle class="st0" cx="242.8" cy="334.1" r="1.9" />
            <circle class="st0" cx="242.8" cy="340.9" r="1.9" />
            <circle class="st0" cx="242.8" cy="347.7" r="1.9" />
            <circle class="st0" cx="242.8" cy="354.5" r="1.9" />
            <circle class="st0" cx="242.8" cy="361.3" r="1.9" />
            <circle class="st0" cx="242.8" cy="368" r="1.9" />
            <circle class="st0" cx="242.8" cy="374.8" r="1.9" />
            <circle class="st0" cx="242.8" cy="381.6" r="1.9" />
            <circle class="st0" cx="242.8" cy="388.4" r="1.9" />
            <circle class="st0" cx="242.8" cy="395.2" r="1.9" />
            <circle class="st0" cx="242.8" cy="402" r="1.9" />
            <circle class="st0" cx="242.8" cy="408.7" r="1.9" />
            <circle class="st0" cx="242.8" cy="422.3" r="1.9" />
            <circle class="st0" cx="242.8" cy="429.1" r="1.9" />
            <circle class="st0" cx="236.1" cy="35.7" r="1.9" />
            <circle class="st0" cx="236.1" cy="42.5" r="1.9" />
            <circle class="st0" cx="236.1" cy="49.3" r="1.9" />
            <circle class="st0" cx="236.1" cy="56" r="1.9" />
            <circle class="st0" cx="236.1" cy="62.8" r="1.9" />
            <circle class="st0" cx="236.1" cy="90" r="1.9" />
            <circle class="st0" cx="236.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="236.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="236.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="236.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="236.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="236.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="236.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="236.1" cy="151" r="1.9" />
            <circle class="st0" cx="236.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="236.1" cy="164.6" r="1.9" />
            <circle class="st0" cx="236.1" cy="171.3" r="1.9" />
            <circle @mouseenter="toggleReviewSection('NewYork')"
                :class="{ 'fill-[#FD833F40]': reviewSections.NewYork, 'fill-[#cbd1d926]': !reviewSections.NewYork }"
                cx="236.1" class="cursor-pointer" cy="178.1" r="8.9" />
            <circle @mouseenter="toggleReviewSection('FloridaKitrum')" cx="236.1"
                :class="{ 'fill-mainColor': reviewSections.NewYork, 'fill-[#5F6177]': !reviewSections.NewYork }"
                class="cursor-pointer" cy="178.1" r="2.5" />
            <circle class="st0" cx="236.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="236.1" cy="239.2" r="1.9" />
            <circle class="st0" cx="236.1" cy="246" r="1.9" />
            <circle class="st0" cx="236.1" cy="259.5" r="1.9" />
            <circle class="st0" cx="236.1" cy="266.3" r="1.9" />
            <circle class="st0" cx="236.1" cy="273.1" r="1.9" />
            <circle class="st0" cx="236.1" cy="279.9" r="1.9" />
            <circle class="st0" cx="236.1" cy="286.6" r="1.9" />
            <circle class="st0" cx="236.1" cy="293.4" r="1.9" />
            <circle class="st0" cx="236.1" cy="300.2" r="1.9" />
            <circle class="st0" cx="236.1" cy="307" r="1.9" />
            <circle class="st0" cx="236.1" cy="313.8" r="1.9" />
            <circle class="st0" cx="236.1" cy="320.6" r="1.9" />
            <circle class="st0" cx="236.1" cy="327.3" r="1.9" />
            <circle class="st0" cx="236.1" cy="354.5" r="1.9" />
            <circle class="st0" cx="236.1" cy="361.3" r="1.9" />
            <circle class="st0" cx="236.1" cy="368" r="1.9" />
            <circle class="st0" cx="236.1" cy="374.8" r="1.9" />
            <circle class="st0" cx="236.1" cy="381.6" r="1.9" />
            <circle class="st0" cx="236.1" cy="388.4" r="1.9" />
            <circle class="st0" cx="236.1" cy="395.2" r="1.9" />
            <circle class="st0" cx="236.1" cy="402" r="1.9" />
            <circle class="st0" cx="236.1" cy="408.7" r="1.9" />
            <circle class="st0" cx="236.1" cy="415.5" r="1.9" />
            <circle class="st0" cx="236.1" cy="422.3" r="1.9" />
            <circle class="st0" cx="236.1" cy="429.1" r="1.9" />
            <circle class="st0" cx="229.3" cy="35.7" r="1.9" />
            <circle class="st0" cx="229.3" cy="42.5" r="1.9" />
            <circle class="st0" cx="229.3" cy="49.3" r="1.9" />
            <circle class="st0" cx="229.3" cy="90" r="1.9" />
            <circle class="st0" cx="229.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="229.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="229.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="229.3" cy="130.7" r="1.9" />
            <circle class="st0" cx="229.3" cy="137.4" r="1.9" />
            <circle class="st0" cx="229.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="229.3" cy="151" r="1.9" />
            <circle class="st0" cx="229.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="229.3" cy="164.6" r="1.9" />
            <circle class="st0" cx="229.3" cy="171.3" r="1.9" />
            <circle class="st0" cx="229.3" cy="178.1" r="1.9" />
            <circle class="st0" cx="229.3" cy="184.9" r="1.9" />
            <circle class="st0" cx="229.3" cy="191.7" r="1.9" />
            <circle class="st0" cx="229.3" cy="239.2" r="1.9" />
            <circle class="st0" cx="229.3" cy="246" r="1.9" />
            <circle class="st0" cx="229.3" cy="266.3" r="1.9" />
            <circle class="st0" cx="229.3" cy="273.1" r="1.9" />
            <circle class="st0" cx="229.3" cy="279.9" r="1.9" />
            <circle class="st0" cx="229.3" cy="286.6" r="1.9" />
            <circle class="st0" cx="229.3" cy="293.4" r="1.9" />
            <circle class="st0" cx="229.3" cy="300.2" r="1.9" />
            <circle class="st0" cx="229.3" cy="307" r="1.9" />
            <circle class="st0" cx="229.3" cy="313.8" r="1.9" />
            <circle class="st0" cx="229.3" cy="320.6" r="1.9" />
            <circle class="st0" cx="229.3" cy="388.4" r="1.9" />
            <circle class="st0" cx="229.3" cy="395.2" r="1.9" />
            <circle class="st0" cx="229.3" cy="402" r="1.9" />
            <circle class="st0" cx="229.3" cy="408.7" r="1.9" />
            <circle class="st0" cx="229.3" cy="415.5" r="1.9" />
            <circle class="st0" cx="229.3" cy="422.3" r="1.9" />
            <circle class="st0" cx="222.5" cy="35.7" r="1.9" />
            <circle class="st0" cx="222.5" cy="42.5" r="1.9" />
            <circle class="st0" cx="222.5" cy="49.3" r="1.9" />
            <circle class="st0" cx="222.5" cy="56" r="1.9" />
            <circle class="st0" cx="222.5" cy="90" r="1.9" />
            <circle class="st0" cx="222.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="222.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="222.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="222.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="222.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="222.5" cy="137.4" r="1.9" />
            <circle class="st0" cx="222.5" cy="151" r="1.9" />
            <circle class="st0" cx="222.5" cy="157.8" r="1.9" />
            <circle class="st0" cx="222.5" cy="164.6" r="1.9" />
            <circle class="st0" cx="222.5" cy="171.3" r="1.9" />
            <circle class="st0" cx="222.5" cy="178.1" r="1.9" />
            <circle class="st0" cx="222.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="222.5" cy="191.7" r="1.9" />
            <circle class="st0" cx="222.5" cy="198.5" r="1.9" />
            <circle class="st0" cx="222.5" cy="205.3" r="1.9" />
            <circle class="st0" cx="222.5" cy="239.2" r="1.9" />
            <circle class="st0" cx="222.5" cy="246" r="1.9" />
            <circle class="st0" cx="222.5" cy="266.3" r="1.9" />
            <circle class="st0" cx="222.5" cy="273.1" r="1.9" />
            <circle class="st0" cx="222.5" cy="279.9" r="1.9" />
            <circle class="st0" cx="222.5" cy="286.6" r="1.9" />
            <circle class="st0" cx="222.5" cy="293.4" r="1.9" />
            <circle class="st0" cx="222.5" cy="300.2" r="1.9" />
            <circle class="st0" cx="222.5" cy="307" r="1.9" />
            <circle class="st0" cx="222.5" cy="313.8" r="1.9" />
            <circle class="st0" cx="215.7" cy="35.7" r="1.9" />
            <circle class="st0" cx="215.7" cy="42.5" r="1.9" />
            <circle class="st0" cx="215.7" cy="49.3" r="1.9" />
            <circle class="st0" cx="215.7" cy="56" r="1.9" />
            <circle class="st0" cx="215.7" cy="62.8" r="1.9" />
            <circle class="st0" cx="215.7" cy="76.4" r="1.9" />
            <circle class="st0" cx="215.7" cy="83.2" r="1.9" />
            <circle class="st0" cx="215.7" cy="90" r="1.9" />
            <circle class="st0" cx="215.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="215.7" cy="164.6" r="1.9" />
            <circle class="st0" cx="215.7" cy="171.3" r="1.9" />
            <circle class="st0" cx="215.7" cy="178.1" r="1.9" />
            <circle class="st0" cx="215.7" cy="184.9" r="1.9" />
            <circle class="st0" cx="215.7" cy="191.7" r="1.9" />
            <circle class="st0" cx="215.7" cy="198.5" r="1.9" />
            <circle class="st0" cx="215.7" cy="205.3" r="1.9" />
            <circle @mouseenter="toggleReviewSection('FloridaKitrum')"
                :class="{ 'fill-[#FD833F40]': reviewSections.FloridaKitrum, 'fill-[#cbd1d926]': !reviewSections.FloridaKitrum }"
                cx="215.7" class="cursor-pointer" cy="212" r="8.9" />
            <circle @mouseenter="toggleReviewSection('FloridaKitrum')" cx="215.7"
                :class="{ 'fill-mainColor': reviewSections.FloridaKitrum, 'fill-[#5F6177]': !reviewSections.FloridaKitrum }"
                class="cursor-pointer" cy="212" r="2.5" />
            <circle class="st0" cx="215.7" cy="218.8" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Florida')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Florida, 'fill-[#cbd1d926]': !reviewSections.Florida }"
                cx="215.7" class="cursor-pointer" cy="225.6" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Florida')" cx="215.7"
                :class="{ 'fill-mainColor': reviewSections.Florida, 'fill-[#5F6177]': !reviewSections.Florida }"
                class="cursor-pointer" cy="225.6" r="2.5" />
            <circle class="st0" cx="215.7" cy="239.2" r="1.9" />
            <circle class="st0" cx="215.7" cy="266.3" r="1.9" />
            <circle class="st0" cx="215.7" cy="273.1" r="1.9" />
            <circle class="st0" cx="215.7" cy="286.6" r="1.9" />
            <circle class="st0" cx="215.7" cy="293.4" r="1.9" />
            <circle class="st0" cx="215.7" cy="300.2" r="1.9" />
            <circle class="st0" cx="208.9" cy="35.7" r="1.9" />
            <circle class="st0" cx="208.9" cy="42.5" r="1.9" />
            <circle class="st0" cx="208.9" cy="49.3" r="1.9" />
            <circle class="st0" cx="208.9" cy="56" r="1.9" />
            <circle class="st0" cx="208.9" cy="62.8" r="1.9" />
            <circle class="st0" cx="208.9" cy="76.4" r="1.9" />
            <circle class="st0" cx="208.9" cy="83.2" r="1.9" />
            <circle class="st0" cx="208.9" cy="90" r="1.9" />
            <circle class="st0" cx="208.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="208.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="208.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="208.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="208.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="208.9" cy="151" r="1.9" />
            <circle class="st0" cx="208.9" cy="157.8" r="1.9" />
            <circle class="st0" cx="208.9" cy="164.6" r="1.9" />
            <circle class="st0" cx="208.9" cy="171.3" r="1.9" />
            <circle class="st0" cx="208.9" cy="178.1" r="1.9" />
            <circle class="st0" cx="208.9" cy="184.9" r="1.9" />
            <circle class="st0" cx="208.9" cy="191.7" r="1.9" />
            <circle class="st0" cx="208.9" cy="198.5" r="1.9" />
            <circle class="st0" cx="208.9" cy="205.3" r="1.9" />
            <circle class="st0" cx="208.9" cy="212" r="1.9" />
            <circle class="st0" cx="208.9" cy="218.8" r="1.9" />
            <circle class="st0" cx="208.9" cy="252.7" r="1.9" />
            <circle class="st0" cx="208.9" cy="259.5" r="1.9" />
            <circle class="st0" cx="208.9" cy="266.3" r="1.9" />
            <circle class="st0" cx="202.2" cy="42.5" r="1.9" />
            <circle class="st0" cx="202.2" cy="49.3" r="1.9" />
            <circle class="st0" cx="202.2" cy="56" r="1.9" />
            <circle class="st0" cx="202.2" cy="62.8" r="1.9" />
            <circle class="st0" cx="202.2" cy="76.4" r="1.9" />
            <circle class="st0" cx="202.2" cy="83.2" r="1.9" />
            <circle class="st0" cx="202.2" cy="90" r="1.9" />
            <circle class="st0" cx="202.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="202.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="202.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="202.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="202.2" cy="151" r="1.9" />
            <circle class="st0" cx="202.2" cy="157.8" r="1.9" />
            <circle class="st0" cx="202.2" cy="164.6" r="1.9" />
            <circle class="st0" cx="202.2" cy="171.3" r="1.9" />
            <circle class="st0" cx="202.2" cy="178.1" r="1.9" />
            <circle class="st0" cx="202.2" cy="184.9" r="1.9" />
            <circle class="st0" cx="202.2" cy="191.7" r="1.9" />
            <circle class="st0" cx="202.2" cy="198.5" r="1.9" />
            <circle class="st0" cx="202.2" cy="205.3" r="1.9" />
            <circle class="st0" cx="202.2" cy="212" r="1.9" />
            <circle class="st0" cx="202.2" cy="218.8" r="1.9" />
            <circle class="st0" cx="202.2" cy="239.2" r="1.9" />
            <circle class="st0" cx="202.2" cy="252.7" r="1.9" />
            <circle class="st0" cx="202.2" cy="259.5" r="1.9" />
            <circle class="st0" cx="202.2" cy="266.3" r="1.9" />
            <circle class="st0" cx="195.4" cy="42.5" r="1.9" />
            <circle class="st0" cx="195.4" cy="49.3" r="1.9" />
            <circle class="st0" cx="195.4" cy="56" r="1.9" />
            <circle class="st0" cx="195.4" cy="69.6" r="1.9" />
            <circle class="st0" cx="195.4" cy="76.4" r="1.9" />
            <circle class="st0" cx="195.4" cy="83.2" r="1.9" />
            <circle class="st0" cx="195.4" cy="90" r="1.9" />
            <circle class="st0" cx="195.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="195.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="195.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="195.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="195.4" cy="151" r="1.9" />
            <circle class="st0" cx="195.4" cy="157.8" r="1.9" />
            <circle class="st0" cx="195.4" cy="164.6" r="1.9" />
            <circle class="st0" cx="195.4" cy="171.3" r="1.9" />
            <circle class="st0" cx="195.4" cy="178.1" r="1.9" />
            <circle class="st0" cx="195.4" cy="184.9" r="1.9" />
            <circle class="st0" cx="195.4" cy="191.7" r="1.9" />
            <circle class="st0" cx="195.4" cy="198.5" r="1.9" />
            <circle class="st0" cx="195.4" cy="205.3" r="1.9" />
            <circle class="st0" cx="195.4" cy="212" r="1.9" />
            <circle class="st0" cx="195.4" cy="218.8" r="1.9" />
            <circle class="st0" cx="195.4" cy="239.2" r="1.9" />
            <circle class="st0" cx="195.4" cy="246" r="1.9" />
            <circle class="st0" cx="195.4" cy="252.7" r="1.9" />
            <circle class="st0" cx="195.4" cy="259.5" r="1.9" />
            <circle class="st0" cx="188.6" cy="42.5" r="1.9" />
            <circle class="st0" cx="188.6" cy="49.3" r="1.9" />
            <circle class="st0" cx="188.6" cy="56" r="1.9" />
            <circle class="st0" cx="188.6" cy="69.6" r="1.9" />
            <circle class="st0" cx="188.6" cy="83.2" r="1.9" />
            <circle class="st0" cx="188.6" cy="96.7" r="1.9" />
            <circle class="st0" cx="188.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="188.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="188.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="188.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="188.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="188.6" cy="144.2" r="1.9" />
            <circle class="st0" cx="188.6" cy="151" r="1.9" />
            <circle class="st0" cx="188.6" cy="157.8" r="1.9" />
            <circle class="st0" cx="188.6" cy="164.6" r="1.9" />
            <circle class="st0" cx="188.6" cy="171.3" r="1.9" />
            <circle class="st0" cx="188.6" cy="178.1" r="1.9" />
            <circle class="st0" cx="188.6" cy="184.9" r="1.9" />
            <circle class="st0" cx="188.6" cy="191.7" r="1.9" />
            <circle class="st0" cx="188.6" cy="198.5" r="1.9" />
            <circle class="st0" cx="188.6" cy="205.3" r="1.9" />
            <circle class="st0" cx="188.6" cy="212" r="1.9" />
            <circle class="st0" cx="188.6" cy="218.8" r="1.9" />
            <circle class="st0" cx="188.6" cy="246" r="1.9" />
            <circle class="st0" cx="188.6" cy="252.7" r="1.9" />
            <circle class="st0" cx="181.8" cy="49.3" r="1.9" />
            <circle class="st0" cx="181.8" cy="62.8" r="1.9" />
            <circle class="st0" cx="181.8" cy="83.2" r="1.9" />
            <circle class="st0" cx="181.8" cy="90" r="1.9" />
            <circle class="st0" cx="181.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="181.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="181.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="181.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="181.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="181.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="181.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="181.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="181.8" cy="151" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Manitoba')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Manitoba, 'fill-[#cbd1d926]': !reviewSections.Manitoba }"
                cx="181.8" class="cursor-pointer" cy="157.8" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Manitoba')" cx="181.8"
                :class="{ 'fill-mainColor': reviewSections.Manitoba, 'fill-[#5F6177]': !reviewSections.Manitoba }"
                class="cursor-pointer" cy="157.8" r="2.5" />
            <circle class="st0" cx="181.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="181.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="181.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="181.8" cy="184.9" r="1.9" />
            <circle class="st0" cx="181.8" cy="191.7" r="1.9" />
            <circle class="st0" cx="181.8" cy="198.5" r="1.9" />
            <circle class="st0" cx="181.8" cy="205.3" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Houston')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Houston, 'fill-[#cbd1d926]': !reviewSections.Houston }"
                cx="181.8" class="cursor-pointer" cy="212" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Houston')" cx="181.8"
                :class="{ 'fill-mainColor': reviewSections.Houston, 'fill-[#5F6177]': !reviewSections.Houston }"
                class="cursor-pointer" cy="212" r="2.5" />
            <circle class="st0" cx="181.8" cy="218.8" r="1.9" />
            <circle class="st0" cx="181.8" cy="246" r="1.9" />
            <circle class="st0" cx="181.8" cy="252.7" r="1.9" />
            <circle class="st0" cx="175" cy="56" r="1.9" />
            <circle class="st0" cx="175" cy="69.6" r="1.9" />
            <circle class="st0" cx="175" cy="83.2" r="1.9" />
            <circle class="st0" cx="175" cy="90" r="1.9" />
            <circle class="st0" cx="175" cy="96.7" r="1.9" />
            <circle class="st0" cx="175" cy="103.5" r="1.9" />
            <circle class="st0" cx="175" cy="110.3" r="1.9" />
            <circle class="st0" cx="175" cy="117.1" r="1.9" />
            <circle class="st0" cx="175" cy="123.9" r="1.9" />
            <circle class="st0" cx="175" cy="130.7" r="1.9" />
            <circle class="st0" cx="175" cy="137.4" r="1.9" />
            <circle class="st0" cx="175" cy="144.2" r="1.9" />
            <circle class="st0" cx="175" cy="151" r="1.9" />
            <circle class="st0" cx="175" cy="157.8" r="1.9" />
            <circle class="st0" cx="175" cy="164.6" r="1.9" />
            <circle class="st0" cx="175" cy="171.3" r="1.9" />
            <circle class="st0" cx="175" cy="178.1" r="1.9" />
            <circle class="st0" cx="175" cy="184.9" r="1.9" />
            <circle class="st0" cx="175" cy="191.7" r="1.9" />
            <circle class="st0" cx="175" cy="198.5" r="1.9" />
            <circle class="st0" cx="175" cy="205.3" r="1.9" />
            <circle class="st0" cx="175" cy="212" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Texas')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Texas, 'fill-[#cbd1d926]': !reviewSections.Texas }" cx="175"
                class="cursor-pointer" cy="218.8" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Texas')" cx="175"
                :class="{ 'fill-mainColor': reviewSections.Texas, 'fill-[#5F6177]': !reviewSections.Texas }"
                class="cursor-pointer" cy="218.8" r="2.5" />
            <circle class="st0" cx="175" cy="225.6" r="1.9" />
            <circle class="st0" cx="175" cy="232.4" r="1.9" />
            <circle class="st0" cx="175" cy="239.2" r="1.9" />
            <circle class="st0" cx="175" cy="246" r="1.9" />
            <circle class="st0" cx="175" cy="252.7" r="1.9" />
            <circle class="st0" cx="168.2" cy="49.3" r="1.9" />
            <circle class="st0" cx="168.2" cy="56" r="1.9" />
            <circle class="st0" cx="168.2" cy="69.6" r="1.9" />
            <circle class="st0" cx="168.2" cy="83.2" r="1.9" />
            <circle class="st0" cx="168.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="168.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="168.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="168.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="168.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="168.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="168.2" cy="137.4" r="1.9" />
            <circle class="st0" cx="168.2" cy="144.2" r="1.9" />
            <circle class="st0" cx="168.2" cy="151" r="1.9" />
            <circle class="st0" cx="168.2" cy="157.8" r="1.9" />
            <circle class="st0" cx="168.2" cy="164.6" r="1.9" />
            <circle class="st0" cx="168.2" cy="171.3" r="1.9" />
            <circle class="st0" cx="168.2" cy="178.1" r="1.9" />
            <circle class="st0" cx="168.2" cy="184.9" r="1.9" />
            <circle class="st0" cx="168.2" cy="191.7" r="1.9" />
            <circle class="st0" cx="168.2" cy="198.5" r="1.9" />
            <circle class="st0" cx="168.2" cy="205.3" r="1.9" />
            <circle class="st1" cx="168.2" cy="212" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Austin')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Austin, 'fill-[#cbd1d926]': !reviewSections.Austin }"
                cx="168.2" class="cursor-pointer" cy="212" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Austin')" cx="168.2"
                :class="{ 'fill-mainColor': reviewSections.Austin, 'fill-[#5F6177]': !reviewSections.Austin }"
                class="cursor-pointer" cy="212" r="2.5" />
            <circle class="st0" cx="168.2" cy="218.8" r="1.9" />
            <circle class="st0" cx="168.2" cy="225.6" r="1.9" />
            <circle class="st0" cx="168.2" cy="232.4" r="1.9" />
            <circle class="st0" cx="168.2" cy="239.2" r="1.9" />
            <circle class="st0" cx="168.2" cy="246" r="1.9" />
            <circle class="st0" cx="161.5" cy="56" r="1.9" />
            <circle class="st0" cx="161.5" cy="62.8" r="1.9" />
            <circle class="st0" cx="161.5" cy="69.6" r="1.9" />
            <circle class="st0" cx="161.5" cy="83.2" r="1.9" />
            <circle class="st0" cx="161.5" cy="90" r="1.9" />
            <circle class="st0" cx="161.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="161.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="161.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="161.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="161.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="161.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="161.5" cy="137.4" r="1.9" />
            <circle class="st0" cx="161.5" cy="144.2" r="1.9" />
            <circle class="st0" cx="161.5" cy="151" r="1.9" />
            <circle class="st0" cx="161.5" cy="157.8" r="1.9" />
            <circle class="st0" cx="161.5" cy="164.6" r="1.9" />
            <circle class="st0" cx="161.5" cy="171.3" r="1.9" />
            <circle class="st0" cx="161.5" cy="178.1" r="1.9" />
            <circle class="st0" cx="161.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="161.5" cy="191.7" r="1.9" />
            <circle class="st0" cx="161.5" cy="198.5" r="1.9" />
            <circle class="st0" cx="161.5" cy="205.3" r="1.9" />
            <circle class="st0" cx="161.5" cy="212" r="1.9" />
            <circle class="st0" cx="161.5" cy="218.8" r="1.9" />
            <circle class="st0" cx="161.5" cy="225.6" r="1.9" />
            <circle class="st0" cx="161.5" cy="232.4" r="1.9" />
            <circle class="st0" cx="161.5" cy="239.2" r="1.9" />
            <circle class="st0" cx="161.5" cy="246" r="1.9" />
            <circle class="st0" cx="154.7" cy="69.6" r="1.9" />
            <circle class="st0" cx="154.7" cy="83.2" r="1.9" />
            <circle class="st0" cx="154.7" cy="90" r="1.9" />
            <circle class="st0" cx="154.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="154.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="154.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="154.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="154.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="154.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="154.7" cy="137.4" r="1.9" />
            <circle class="st0" cx="154.7" cy="144.2" r="1.9" />
            <circle class="st0" cx="154.7" cy="151" r="1.9" />
            <circle class="st0" cx="154.7" cy="157.8" r="1.9" />
            <circle class="st0" cx="154.7" cy="164.6" r="1.9" />
            <circle class="st0" cx="154.7" cy="171.3" r="1.9" />
            <circle class="st0" cx="154.7" cy="178.1" r="1.9" />
            <circle class="st0" cx="154.7" cy="184.9" r="1.9" />
            <circle class="st0" cx="154.7" cy="191.7" r="1.9" />
            <circle class="st0" cx="154.7" cy="198.5" r="1.9" />
            <circle class="st0" cx="154.7" cy="205.3" r="1.9" />
            <circle class="st0" cx="154.7" cy="212" r="1.9" />
            <circle class="st0" cx="154.7" cy="218.8" r="1.9" />
            <circle class="st0" cx="154.7" cy="225.6" r="1.9" />
            <circle class="st0" cx="154.7" cy="232.4" r="1.9" />
            <circle class="st0" cx="147.9" cy="56" r="1.9" />
            <circle class="st0" cx="147.9" cy="62.8" r="1.9" />
            <circle class="st0" cx="147.9" cy="69.6" r="1.9" />
            <circle class="st0" cx="147.9" cy="90" r="1.9" />
            <circle class="st0" cx="147.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="147.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="147.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="147.9" cy="123.9" r="1.9" />
            <circle @mouseenter="toggleReviewSection('Canada')"
                :class="{ 'fill-[#FD833F40]': reviewSections.Canada, 'fill-[#cbd1d926]': !reviewSections.Canada }"
                cx="147.9" class="cursor-pointer" cy="123.9" r="8.9" />
            <circle @mouseenter="toggleReviewSection('Canada')" cx="147.9"
                :class="{ 'fill-mainColor': reviewSections.Canada, 'fill-[#5F6177]': !reviewSections.Canada }"
                class="cursor-pointer" cy="123.9" r="2.5" />
            <circle class="st0" cx="147.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="147.9" cy="137.4" r="1.9" />
            <circle class="st0" cx="147.9" cy="144.2" r="1.9" />
            <circle class="st0" cx="147.9" cy="151" r="1.9" />
            <circle class="st0" cx="147.9" cy="157.8" r="1.9" />
            <circle class="st0" cx="147.9" cy="164.6" r="1.9" />
            <circle class="st0" cx="147.9" cy="171.3" r="1.9" />
            <circle class="st0" cx="147.9" cy="178.1" r="1.9" />
            <circle class="st0" cx="147.9" cy="184.9" r="1.9" />
            <circle class="st0" cx="147.9" cy="191.7" r="1.9" />
            <circle class="st0" cx="147.9" cy="198.5" r="1.9" />
            <circle class="st0" cx="147.9" cy="205.3" r="1.9" />
            <circle class="st0" cx="147.9" cy="212" r="1.9" />
            <circle class="st0" cx="147.9" cy="218.8" r="1.9" />
            <circle class="st0" cx="147.9" cy="225.6" r="1.9" />
            <circle class="st0" cx="147.9" cy="232.4" r="1.9" />
            <circle class="st0" cx="141.1" cy="62.8" r="1.9" />
            <circle class="st0" cx="141.1" cy="69.6" r="1.9" />
            <circle class="st0" cx="141.1" cy="76.4" r="1.9" />
            <circle class="st0" cx="141.1" cy="90" r="1.9" />
            <circle class="st0" cx="141.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="141.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="141.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="141.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="141.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="141.1" cy="137.4" r="1.9" />
            <circle class="st0" cx="141.1" cy="144.2" r="1.9" />
            <circle class="st0" cx="141.1" cy="151" r="1.9" />
            <circle class="st0" cx="141.1" cy="157.8" r="1.9" />
            <circle class="st0" cx="141.1" cy="164.6" r="1.9" />
            <circle class="st0" cx="141.1" cy="171.3" r="1.9" />
            <circle class="st0" cx="141.1" cy="178.1" r="1.9" />
            <circle class="st0" cx="141.1" cy="184.9" r="1.9" />
            <circle class="st0" cx="141.1" cy="191.7" r="1.9" />
            <circle class="st0" cx="141.1" cy="198.5" r="1.9" />
            <circle class="st0" cx="141.1" cy="205.3" r="1.9" />
            <circle class="st0" cx="141.1" cy="212" r="1.9" />
            <circle class="st0" cx="141.1" cy="218.8" r="1.9" />
            <circle class="st0" cx="141.1" cy="225.6" r="1.9" />
            <circle class="st0" cx="134.3" cy="62.8" r="1.9" />
            <circle class="st0" cx="134.3" cy="69.6" r="1.9" />
            <circle class="st0" cx="134.3" cy="83.2" r="1.9" />
            <circle class="st0" cx="134.3" cy="90" r="1.9" />
            <circle class="st0" cx="134.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="134.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="134.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="134.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="134.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="134.3" cy="130.7" r="1.9" />
            <circle class="st0" cx="134.3" cy="137.4" r="1.9" />
            <circle class="st0" cx="134.3" cy="144.2" r="1.9" />
            <circle class="st0" cx="134.3" cy="151" r="1.9" />
            <circle class="st0" cx="134.3" cy="157.8" r="1.9" />
            <circle class="st0" cx="134.3" cy="164.6" r="1.9" />
            <circle class="st0" cx="134.3" cy="171.3" r="1.9" />
            <circle class="st0" cx="134.3" cy="178.1" r="1.9" />
            <circle class="st0" cx="134.3" cy="184.9" r="1.9" />
            <circle class="st0" cx="134.3" cy="191.7" r="1.9" />
            <circle class="st0" cx="134.3" cy="198.5" r="1.9" />
            <circle class="st0" cx="134.3" cy="205.3" r="1.9" />
            <circle class="st0" cx="134.3" cy="212" r="1.9" />
            <circle class="st0" cx="127.5" cy="62.8" r="1.9" />
            <circle class="st0" cx="127.5" cy="69.6" r="1.9" />
            <circle class="st0" cx="127.5" cy="83.2" r="1.9" />
            <circle class="st0" cx="127.5" cy="90" r="1.9" />
            <circle class="st0" cx="127.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="127.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="127.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="127.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="127.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="127.5" cy="137.4" r="1.9" />
            <circle class="st0" cx="127.5" cy="144.2" r="1.9" />
            <circle class="st0" cx="127.5" cy="151" r="1.9" />
            <circle class="st0" cx="127.5" cy="157.8" r="1.9" />
            <circle class="st0" cx="127.5" cy="164.6" r="1.9" />
            <circle class="st0" cx="127.5" cy="171.3" r="1.9" />
            <circle class="st0" cx="127.5" cy="178.1" r="1.9" />
            <circle class="st0" cx="127.5" cy="184.9" r="1.9" />
            <circle class="st0" cx="127.5" cy="191.7" r="1.9" />
            <circle class="st0" cx="127.5" cy="198.5" r="1.9" />
            <circle class="st0" cx="127.5" cy="205.3" r="1.9" />
            <circle class="st0" cx="120.8" cy="69.6" r="1.9" />
            <circle class="st0" cx="120.8" cy="76.4" r="1.9" />
            <circle class="st0" cx="120.8" cy="83.2" r="1.9" />
            <circle class="st0" cx="120.8" cy="90" r="1.9" />
            <circle class="st0" cx="120.8" cy="96.7" r="1.9" />
            <circle class="st0" cx="120.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="120.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="120.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="120.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="120.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="120.8" cy="137.4" r="1.9" />
            <circle class="st0" cx="120.8" cy="144.2" r="1.9" />
            <circle class="st0" cx="120.8" cy="151" r="1.9" />
            <circle class="st0" cx="120.8" cy="157.8" r="1.9" />
            <circle class="st0" cx="120.8" cy="164.6" r="1.9" />
            <circle class="st0" cx="120.8" cy="171.3" r="1.9" />
            <circle class="st0" cx="120.8" cy="178.1" r="1.9" />
            <circle class="st0" cx="120.8" cy="184.9" r="1.9" />
            <circle class="st0" cx="120.8" cy="191.7" r="1.9" />
            <circle class="st0" cx="120.8" cy="198.5" r="1.9" />
            <circle class="st0" cx="114" cy="83.2" r="1.9" />
            <circle class="st0" cx="114" cy="90" r="1.9" />
            <circle class="st0" cx="114" cy="96.7" r="1.9" />
            <circle class="st0" cx="114" cy="103.5" r="1.9" />
            <circle class="st0" cx="114" cy="110.3" r="1.9" />
            <circle class="st0" cx="114" cy="117.1" r="1.9" />
            <circle class="st0" cx="114" cy="123.9" r="1.9" />
            <circle class="st0" cx="114" cy="130.7" r="1.9" />
            <circle class="st0" cx="114" cy="137.4" r="1.9" />
            <circle class="st0" cx="114" cy="144.2" r="1.9" />
            <circle class="st0" cx="114" cy="151" r="1.9" />
            <circle class="st0" cx="114" cy="157.8" r="1.9" />
            <circle class="st0" cx="114" cy="164.6" r="1.9" />
            <circle class="st0" cx="107.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="107.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="107.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="107.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="107.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="107.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="107.2" cy="137.4" r="1.9" />
            <circle class="st0" cx="107.2" cy="144.2" r="1.9" />
            <circle class="st0" cx="107.2" cy="151" r="1.9" />
            <circle class="st0" cx="107.2" cy="157.8" r="1.9" />
            <circle class="st0" cx="107.2" cy="164.6" r="1.9" />
            <circle class="st0" cx="100.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="100.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="100.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="100.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="100.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="100.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="100.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="100.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="100.4" cy="151" r="1.9" />
            <circle class="st0" cx="93.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="93.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="93.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="93.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="93.6" cy="130.7" r="1.9" />
            <circle class="st0" cx="93.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="93.6" cy="144.2" r="1.9" />
            <circle class="st0" cx="93.6" cy="151" r="1.9" />
            <circle class="st0" cx="86.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="86.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="86.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="86.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="86.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="86.9" cy="137.4" r="1.9" />
            <circle class="st0" cx="80.1" cy="96.7" r="1.9" />
            <circle class="st0" cx="80.1" cy="103.5" r="1.9" />
            <circle class="st0" cx="80.1" cy="110.3" r="1.9" />
            <circle class="st0" cx="80.1" cy="117.1" r="1.9" />
            <circle class="st0" cx="80.1" cy="123.9" r="1.9" />
            <circle class="st0" cx="80.1" cy="130.7" r="1.9" />
            <circle class="st0" cx="73.3" cy="96.7" r="1.9" />
            <circle class="st0" cx="73.3" cy="103.5" r="1.9" />
            <circle class="st0" cx="73.3" cy="110.3" r="1.9" />
            <circle class="st0" cx="73.3" cy="117.1" r="1.9" />
            <circle class="st0" cx="73.3" cy="123.9" r="1.9" />
            <circle class="st0" cx="73.3" cy="130.7" r="1.9" />
            <circle class="st0" cx="66.5" cy="96.7" r="1.9" />
            <circle class="st0" cx="66.5" cy="103.5" r="1.9" />
            <circle class="st0" cx="66.5" cy="110.3" r="1.9" />
            <circle class="st0" cx="66.5" cy="117.1" r="1.9" />
            <circle class="st0" cx="66.5" cy="123.9" r="1.9" />
            <circle class="st0" cx="66.5" cy="130.7" r="1.9" />
            <circle class="st0" cx="59.7" cy="96.7" r="1.9" />
            <circle class="st0" cx="59.7" cy="103.5" r="1.9" />
            <circle class="st0" cx="59.7" cy="110.3" r="1.9" />
            <circle class="st0" cx="59.7" cy="117.1" r="1.9" />
            <circle class="st0" cx="59.7" cy="123.9" r="1.9" />
            <circle class="st0" cx="59.7" cy="130.7" r="1.9" />
            <circle class="st0" cx="52.9" cy="96.7" r="1.9" />
            <circle class="st0" cx="52.9" cy="103.5" r="1.9" />
            <circle class="st0" cx="52.9" cy="110.3" r="1.9" />
            <circle class="st0" cx="52.9" cy="117.1" r="1.9" />
            <circle class="st0" cx="52.9" cy="123.9" r="1.9" />
            <circle class="st0" cx="52.9" cy="130.7" r="1.9" />
            <circle class="st0" cx="52.9" cy="137.4" r="1.9" />
            <circle class="st0" cx="46.2" cy="90" r="1.9" />
            <circle class="st0" cx="46.2" cy="96.7" r="1.9" />
            <circle class="st0" cx="46.2" cy="103.5" r="1.9" />
            <circle class="st0" cx="46.2" cy="110.3" r="1.9" />
            <circle class="st0" cx="46.2" cy="117.1" r="1.9" />
            <circle class="st0" cx="46.2" cy="123.9" r="1.9" />
            <circle class="st0" cx="46.2" cy="130.7" r="1.9" />
            <circle class="st0" cx="46.2" cy="137.4" r="1.9" />
            <circle class="st0" cx="46.2" cy="144.2" r="1.9" />
            <circle class="st0" cx="39.4" cy="90" r="1.9" />
            <circle class="st0" cx="39.4" cy="96.7" r="1.9" />
            <circle class="st0" cx="39.4" cy="103.5" r="1.9" />
            <circle class="st0" cx="39.4" cy="110.3" r="1.9" />
            <circle class="st0" cx="39.4" cy="117.1" r="1.9" />
            <circle class="st0" cx="39.4" cy="123.9" r="1.9" />
            <circle class="st0" cx="39.4" cy="130.7" r="1.9" />
            <circle class="st0" cx="39.4" cy="137.4" r="1.9" />
            <circle class="st0" cx="39.4" cy="144.2" r="1.9" />
            <circle class="st0" cx="32.6" cy="96.7" r="1.9" />
            <circle class="st0" cx="32.6" cy="103.5" r="1.9" />
            <circle class="st0" cx="32.6" cy="110.3" r="1.9" />
            <circle class="st0" cx="32.6" cy="117.1" r="1.9" />
            <circle class="st0" cx="32.6" cy="123.9" r="1.9" />
            <circle class="st0" cx="32.6" cy="130.7" r="1.9" />
            <circle class="st0" cx="32.6" cy="137.4" r="1.9" />
            <circle class="st0" cx="32.6" cy="144.2" r="1.9" />
            <circle class="st0" cx="32.6" cy="151" r="1.9" />
            <circle class="st0" cx="25.8" cy="103.5" r="1.9" />
            <circle class="st0" cx="25.8" cy="110.3" r="1.9" />
            <circle class="st0" cx="25.8" cy="117.1" r="1.9" />
            <circle class="st0" cx="25.8" cy="123.9" r="1.9" />
            <circle class="st0" cx="25.8" cy="130.7" r="1.9" />
            <circle class="st0" cx="25.8" cy="151" r="1.9" />
            <circle class="st0" cx="19" cy="103.5" r="1.9" />
            <circle class="st0" cx="19" cy="110.3" r="1.9" />
            <circle class="st0" cx="19" cy="117.1" r="1.9" />
            <circle class="st0" cx="19" cy="151" r="1.9" />
            <circle class="st0" cx="19" cy="157.8" r="1.9" />
        </svg>
        <div v-if="reviewSections.Ethiopia" class="absolute flex left-[56.8%] bottom-[43%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Nathan Girma
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Trustech IT Solutions</p>
                <p class="text-grayCase text-sm mt-1">Giraffe Software is an experienced and professional team.</p>
            </div>
        </div>
        <div v-if="reviewSections.Florida" class="absolute flex left-[25.5%] bottom-[52%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Partnership Coordinator
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Software Development Company</p>
                <p class="text-grayCase text-sm mt-1">They have smooth communication, an easy engagement process, and
                    qualified resources.</p>
            </div>
        </div>
        <div v-if="reviewSections.Lithuania" class="absolute flex left-[55.2%] bottom-[72%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Ibrahim Bashir
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">WeissFari</p>
                <p class="text-grayCase text-sm mt-1">They know exactly what they are doing and are very effective in
                    delivery.</p>
            </div>
        </div>
        <div v-if="reviewSections.Lviv" class="absolute flex left-[56.8%] bottom-[66%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Serhii Harasymchuk
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">JetSoftPro</p>
                <p class="text-grayCase text-sm mt-1">They are skilled and responsible developers with a good level of
                    commitment and communication.</p>
            </div>
        </div>
        <div v-if="reviewSections.Houston" class="absolute flex left-[21.5%] bottom-[56%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        James Lenoble
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">GrowMindGrow</p>
                <p class="text-grayCase text-sm mt-1">Their reliability, tech expertise and quality of service set them
                    apart.</p>
            </div>
        </div>
        <div v-if="reviewSections.Estonia" class="absolute flex left-[56%] bottom-[75%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        LMS Development for School
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">LMS System</p>
                <p class="text-grayCase text-sm mt-1">They always strived to deliver a quality product, and they didn't
                    leave much to chance.</p>
            </div>
        </div>
        <div v-if="reviewSections.Israel" class="absolute flex left-[57.6%] bottom-[56%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Ori Levi
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Sosimple</p>
                <p class="text-grayCase text-sm mt-1">...I am happy I can finally start gaining traffic and fulfill my
                    goals.</p>
            </div>
        </div>
        <div v-if="reviewSections.Manitoba" class="absolute flex left-[21.5%] bottom-[67%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Jeff Cullen
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">SEM Auditors</p>
                <p class="text-grayCase text-sm mt-1">I was impressed by their deep expertise in Laravel.</p>
            </div>
        </div>
        <div v-if="reviewSections.GermanyMinden" class="absolute flex left-[52%] bottom-[67%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Johannes Renaud
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">LOOXIS GmbH</p>
                <p class="text-grayCase text-sm mt-1">We liked their work so much we've brought them onboard other software
                    development projects...</p>
            </div>
        </div>
        <div v-if="reviewSections.Netherlands" class="absolute flex left-[49.6%] bottom-[67%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Dennis de Graaf
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Cryptonomic</p>
                <p class="text-grayCase text-sm mt-1">Giraffe Software's quality of code, sense of responsibility, and great
                    communication stood out to us.</p>
            </div>
        </div>
        <div v-if="reviewSections.Hungary" class="absolute flex left-[52.7%] bottom-[65%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Johan van der Walt
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Evosolve</p>
                <p class="text-grayCase text-sm mt-1">I knew that a knowledgeable team controlled the whole process, and I
                    was never worried about the project's results.</p>
            </div>
        </div>
        <div v-if="reviewSections.Spain" class="absolute flex left-[47.2%] bottom-[60%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Elena Ursache
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Novalins</p>
                <p class="text-grayCase text-sm mt-1">… working with Giraffe Software has been a tremendous step forward
                    from a business perspective.</p>
            </div>
        </div>
        <div v-if="reviewSections.Denmark" class="absolute flex left-[49.6%] bottom-[70%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Outsourced Dev & Testing for Analytics Company
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Analytics Company</p>
                <p class="text-grayCase text-sm mt-1">Giraffe Software cared about the work and didn't just do it because we
                    said so.</p>
            </div>
        </div>
        <div v-if="reviewSections.Austin" class="absolute flex left-[19.8%] bottom-[55%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Jasper K. Juhl
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Great Agent, Inc.</p>
                <p class="text-grayCase text-sm mt-1">I wish more companies were as good as Giraffe Software</p>
            </div>
        </div>
        <div v-if="reviewSections.FloridaKitrum" class="absolute flex left-[25.5%] bottom-[55%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Evgenia Kuzmenko
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">KitRUM LLC.</p>
                <p class="text-grayCase text-sm mt-1">Giraffe Software's coding assistance helped scale the platform
                    nationally. Their dedicated team was professional, efficient, and technically skilled.</p>
            </div>
        </div>
        <div v-if="reviewSections.SouthAfrica" class="absolute flex left-[53.55%] bottom-[24.9%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Vue.JS Web App
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Software development company</p>
                <p class="text-grayCase text-sm mt-1">An invaluable addition to the team. They were instrumental in getting
                    a pretty difficult and complicated SPA to market and helping me support it to date.</p>
            </div>
        </div>
        <div v-if="reviewSections.NewYork" class="absolute flex left-[27.85%] bottom-[63%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        eCommerce Platform
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Sleep wellness company</p>
                <p class="text-grayCase text-sm mt-1">They delivered high-quality work, were always available, and
                    communicated well with our team. They were also very receptive to feedback and their code meshed well
                    with the existing project.</p>
            </div>
        </div>
        <div v-if="reviewSections.Canada" class="absolute flex left-[17.45%] bottom-[75%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Operations Management Startup
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Startup for improving productivity and collaboration</p>
                <p class="text-grayCase text-sm mt-1">They quickly understood our existing complicated frontend application,
                    and made performance improvements, clean up technical debt, and built the features we requested on time
                    and gave good suggestions for improvements..</p>
            </div>
        </div>
        <div v-if="reviewSections.GermanyHaltern" class="absolute flex left-[51.18%] bottom-[66%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Web Application Project
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Driverless transport systems company</p>
                <p class="text-grayCase text-sm mt-1">The work met all existing standards perfectly, they delivered on time,
                    were always available, and provided project backup whenever I needed. Communication with Giraffe was
                    smooth and professional.</p>
            </div>
        </div>
        <div v-if="reviewSections.IsraelQiryat" class="absolute flex left-[56.8%] bottom-[56%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Web Development Project
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Video streaming company</p>
                <p class="text-grayCase text-sm mt-1">Helped us to speed up the development of the project on the backend
                    side with Node.js technology. The communication & reporting were great and the tasks were completed with
                    high quality.</p>
            </div>
        </div>
        <div v-if="reviewSections.Texas" class="absolute flex left-[20.7%] bottom-[54%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        eLearning Platform
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Children's learning tools platform</p>
                <p class="text-grayCase text-sm mt-1">Super value at the international level! We're an experienced shop and
                    very selective about the talent we hire and Giraffe is among the best!</p>
            </div>
        </div>
        <div v-if="reviewSections.Germany" class="absolute flex left-[49.6%] bottom-[64%]">
            <div>
                <span class="w-3 h-3 rounded-full border relative -left-[5px] block border-mainColor"></span>
                <span class="h-full block border-l border-mainColor"></span>
            </div>
            <div class="p-6 w-[388px] rounded-[20px] bg-white border border-grayBorder">
                <div class="flex items-start justify-between">
                    <h2 class="font-semibold text-grayText">
                        Advertising Platform Development
                    </h2>
                    <img alt="quote-icon" class="h-6 w-7" src="../../../images/quote.png" />
                </div>
                <p class="text-gray text-[10px]">Advertising platform</p>
                <p class="text-grayCase text-sm mt-1">The work met all existing standards perfectly, they delivered on time,
                    were always available, and provided project backup. Also provided DevOps and Designer engineers, they
                    understood the tasks at hand very well.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DottedMap",
    data() {
        return {
            reviewSections: {
                Ethiopia: false,
                Florida: false,
                Lithuania: false,
                Lviv: false,
                Houston: false,
                Estonia: false,
                Israel: false,
                Manitoba: false,
                GermanyMinden: false,
                Netherlands: false,
                Hungary: false,
                Spain: false,
                Denmark: false,
                Austin: false,
                FloridaKitrum: false,
                SouthAfrica: false,
                NewYork: false,
                Canada: false,
                GermanyHaltern: false,
                IsraelQiryat: false,
                Texas: false,
                Germany: false
            }
        };
    },
    methods: {
        toggleReviewSection(section) {
            for (const key in this.reviewSections) {
                this.reviewSections[key] = key === section;
            }
        }
    },
};
</script>
